// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:56:58.251Z
// Property: Stonebriar Woods Apartment Homes (ID: 6767906449167614)
// Collections: 36 amenities, 8 floorplans (live), 19 photos, 77 POIs, 12 reviews, 7 virtual tours, 6 office hours, 16 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167614",
  "property_external_id": "1124195",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/stonebriar-woods-apartment-homes-overland-park-ks/1905k66/",
  "property_google_business_url": "https://www.google.com/maps/place/Stonebriar+Woods+Apartment+Homes/@38.9080313,-94.7263883,890m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0eab48353da0d:0x9e26eda22019e348!8m2!3d38.9080313!4d-94.7263883!16s%2Fg%2F1tvw5fyy?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124195 p1099147",
  "property_status": null,
  "property_slug": "stonebriar-woods-apartment-homes",
  "property_name": "Stonebriar Woods Apartment Homes",
  "property_website_url": "https://www.stonebriarwoods.com/",
  "property_domain": "https://www.stonebriarwoods.com/",
  "property_address": "12401 W 120th St",
  "property_full_address": "12401 W 120th St, Overland Park, KS 66213",
  "property_address_1": "12401 W 120th St",
  "property_address_2": null,
  "property_address_city": "Overland Park",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66213",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Regent's Crest",
  "property_address_latitude": "38.9080258",
  "property_address_longitude": "-94.72639559999999",
  "property_email": "rentcafe.sw@pricekc.com",
  "property_phone": "(913) 386-7412",
  "property_call_tracking_phone": "913-386-7412",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Wooded calm, connected Overland Park living.</strong> Explore one-, two-, and three-bedroom apartment homes with tree-framed views, everyday in-home comforts, and direct access to Indian Creek Trail—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Stonebriar Woods in person.</p>",
  "property_long_description": "<p>Stonebriar Woods Apartment Homes is a wooded apartment community in Overland Park, KS, tucked next to the Indian Creek Trail and steps from Quivira Park. Here, a morning run, an evening bike ride, or a walk with the dog starts right outside your door. The community is managed by Price Brothers Management, a Kansas City family-owned company since 1922.</p><p>Life at Stonebriar Woods is built around getting outside and getting to know your neighbors. Spend summer afternoons at the pool and sundeck, play tennis or sand volleyball, and gather at the clubhouse when the weather turns. Resident events happen throughout the year, including the Puppy Paddle, when the pool goes to the dogs. Inside, every apartment has an in-unit washer and dryer and a private balcony or patio overlooking the trees.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b667-c0b6-711a-bf79-b1ee640a6869.webp",
  "property_featured_image_media": {
    "alt_text": "Open concept living and dining area with kitchen view.",
    "public_id": "01a0b667-c0b6-711a-bf79-b1ee640a6869",
    "storage_key": "property/6767906449167614/01a0b667-c0b6-711a-bf79-b1ee640a6869.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "476",
  "property_year_built": "1996",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.69747899159664",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://stonebriarwoods.securecafeapplicant.com/onlineleasing/content3/access/stonebriar-woods/floorplans",
  "property_resident_portal_url": "https://stonebriarwoods.securecafe.com/residentservices/stonebriar-woods/userlogin.aspx",
  "property_apply_now_url": "https://stonebriarwoods.securecafeapplicant.com/onlineleasing/content3/access/stonebriar-woods/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc989-a6be-7147-8c66-7df7dbcc2c17.webp",
  "property_primary_logo_media": {
    "alt_text": "Stonebriar Woods Apartment Homes logo",
    "public_id": "019fc989-a6be-7147-8c66-7df7dbcc2c17",
    "storage_key": "property/6767906449167614/019fc989-a6be-7147-8c66-7df7dbcc2c17.webp",
    "width": 1800,
    "height": 300
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a1a27f-13ee-77f8-b546-ed95598b92f5.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Stonebriar Woods Apartment Homes logo",
    "public_id": "01a1a27f-13ee-77f8-b546-ed95598b92f5",
    "storage_key": "property/6767906449167614/01a1a27f-13ee-77f8-b546-ed95598b92f5.webp",
    "width": 1538,
    "height": 225
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-d70f-76de-9a4b-30edd850ac7a.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc98a-d70f-76de-9a4b-30edd850ac7a",
    "storage_key": "property/6767906449167614/019fc98a-d70f-76de-9a4b-30edd850ac7a.webp",
    "width": 1280,
    "height": 213
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#54585A",
  "property_secondary_color": "#154734",
  "property_font_color": null,
  "property_color_4": "#6BBBAE",
  "property_color_3": "#4F758B",
  "property_color_5": "#FDF5BF",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "732 - 1260",
  "property_sqft_min": "732",
  "property_sqft_max": "1260",
  "property_price_range": "1290 - 4533",
  "property_price_min": "1290",
  "property_price_max": "4533",
  "property_available_units": 30,
  "property_facebook_url": "https://www.facebook.com/StonebriarWoodsApts",
  "property_instagram_url": "https://www.instagram.com/stonebriarwoodsapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJDdpTg7TqwIcRSOMZIKLtJp4",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Stonebriar Woods Apartment Homes",
  "property_home_romance_title": "Embrace a Life You’ll Love at Our Apartment Community",
  "property_home_amenities_blurb": "<p>From the swimming pool and fitness center to in-unit washers and dryers, Stonebriar Woods Apartment Homes is built around everyday comfort. Review the <a href=\"/amenities\">full list of amenities</a> to see what’s included.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find a layout that moves with you.</strong> Choose from eight one-, two-, and three-bedroom floor plans in Overland Park, with everyday comforts like in-home washer/dryer sets, walk-in closets, extra storage, and private patios or balconies. Select homes add standout finishes such as stainless steel appliances, simulated wood floors, built-in desks or studies, vaulted ceilings, and wood-burning fireplaces.</p>",
  "property_home_gallery_blurb": "<p>Scroll through the <a href=\"/gallery\">photo gallery</a> for a closer look at the apartment interiors, community spaces and amenities that make Stonebriar Woods Apartment Homes feel like home.</p>",
  "property_home_neighborhood_blurb": "<p>Stonebriar Woods Apartment Homes sits minutes from Johnson County Community College, Quivira Park, and the Indian Creek Trail, with Overland Park shopping, dining, and entertainment close by. Visit our <a href=\"/neighborhood\">Neighborhood page</a> to see what’s nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to praise.</strong> Reviews highlight Stonebriar Woods Apartment Homes’ responsive maintenance, friendly office team, quiet atmosphere, and well-kept grounds. Spacious rooms, clean community spaces, reasonable rent, and a convenient Overland Park location add to the appeal. Read the reviews to see why everyday living here is often described as easy—and “Really a place to call home.”</p>",
  "property_neighborhood_blurb": "<p>Stonebriar Woods Apartment Homes is located near West 120th Street and Quivira Road in Overland Park, KS, right next to the Indian Creek Trail and steps from Quivira Park. Thomas S. Stoll Memorial Park and the Stoll Off-Leash Dog Park are a short walk away, and Ernie Miller Park &amp; Nature Center and Shawnee Mission Park are a short drive.</p><p>Looking for a place to eat near Stonebriar Woods? Our team recommends Ricco’s Italian Bistro, The Wooden Spoon, and Barley’s Kitchen &amp; Tap, and Scooter’s Coffee is close by for your morning coffee. Talk of the Town Grill &amp; Bar, Capriotti’s, and Sawasdee Thai Cuisine are also nearby, with shopping at Olathe Pointe and Northridge Plaza and Par Exsalonce for salon services.</p><p>Johnson County Community College, the KU Edwards Campus, and St. Thomas Aquinas High School are all near Stonebriar Woods. Overland Park Regional Medical Center and major highways are minutes away. Employers within about five miles include Saint Luke’s South Hospital, Accenture, and UnitedLex, and Amazon, AECOM, and Jacobs Engineering are within a half-hour drive.</p><p>Explore our <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a>, or <a href=\"/contact-us\">contact us</a> to schedule a tour.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Stonebriar Woods Apartment Homes offers outdoor recreation and community amenities. The swimming pool and sundeck are the place to be on summer afternoons, the tennis and sand volleyball courts keep the competition friendly, and the fitness center makes it easy to stick to a routine. The clubhouse is ready when it’s time to gather indoors.</p><p>The setting is part of the appeal. Stonebriar Woods sits right next to the Indian Creek Trail, one of Johnson County’s most popular paths for running, biking, and dog walks, and Quivira Park is steps away.</p><p>Inside, every apartment has an in-unit washer and dryer, air conditioning, and a private balcony or patio. Select homes add a wood-burning fireplace, vaulted ceilings, simulated wood floors, a gourmet kitchen with stainless steel appliances, or a built-in study.</p><p>Ready to see these amenities in person? <a href=\"/schedule-a-tour\">Schedule a tour</a> of Stonebriar Woods Apartment Homes today.</p>",
  "property_applynow_blurb": "<p><strong>Ready to settle into wooded Overland Park calm?</strong> Stonebriar Woods Apartment Homes pairs tree-framed views and landscaped courtyards with comfortable one-, two-, and three-bedroom layouts. Start your online application today and take the next step toward calling this connected Regent’s Crest setting home.</p>",
  "property_contactus_blurb": "<p>Looking for more information about Stonebriar Woods Apartment Homes? Our leasing team can answer questions about available <a href=\"/floor-plans\">floor plans</a>, pricing, community and apartment <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">scheduling a tour</a>.</p><p>Call us, visit the leasing office, or complete the contact form above. We look forward to hearing from you.</p>",
  "property_faqs_blurb": "<p>Find answers to common questions about applications, deposits, lease terms, pets, utilities, renters insurance, and maintenance requests at Stonebriar Woods Apartment Homes. You can also review our <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a> for more information.</p><p>If you don’t see the answer you need, <a href=\"/contact-us\">contact us</a>. We’re happy to help.</p>",
  "property_floorplans_blurb": "<p>Stonebriar Woods Apartment Homes offers eight floor plans in Overland Park, KS. One-bedroom apartments start at 732 square feet, two-bedroom homes range from 905 to 1,017 square feet, and the three-bedroom layout has 1,260 square feet.</p><p>Every apartment at Stonebriar Woods includes an in-unit washer and dryer, air conditioning, and a private balcony or patio. Select homes add simulated wood floors, vaulted ceilings, a wood-burning fireplace, a gourmet kitchen with stainless steel appliances, or a built-in study.</p><p>Compare pricing and availability above, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite in person.</p>",
  "property_gallery_blurb": "<p>Browse Stonebriar Woods Apartment Homes photos to see apartment interiors with in-unit washers and dryers and private balconies and patios, plus select homes with simulated wood floors, vaulted ceilings, or a wood-burning fireplace.</p><p>Then see the swimming pool and sundeck, the fitness center, the clubhouse, the tennis and sand volleyball courts, and the wooded grounds along the Indian Creek Trail. After browsing, compare <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_interactivemap_blurb": "<p>Use the interactive property map to explore available apartments at Stonebriar Woods Apartment Homes by building, floor plan, and location within the community. Select a unit to view pricing, square footage, and availability, then review the full list of <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a> for more details. Ready to find your new home? <a href=\"/contact-us\">Contact us</a> to schedule a tour.</p>",
  "property_pets_blurb": "<p>Stonebriar Woods Apartment Homes welcomes cats and dogs, with a maximum of two pets per apartment.</p><ul><li><strong>Monthly pet rent:</strong> $25 per pet</li><li><strong>Non-refundable pet fee:</strong> $300 for one pet or $500 for two pets</li></ul><p><strong>Breed restrictions:</strong> Restricted breeds include Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and mixes containing any of these breeds. Management may restrict additional breeds. Exotic, feral, wild, or inherently dangerous animals are not permitted.</p><p>As part of the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a>, every pet-owning resident gains access to discounts at local pet-related businesses with payment of the one-time pet fee. Learn more on the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Management website</a>.</p>",
  "property_referafriend_blurb": "<p><strong>Share wooded calm and connected Overland Park living.</strong> Love the tree-framed views, landscaped courtyards, Indian Creek Trail access, and easy everyday comforts at Stonebriar Woods? Refer a friend today and invite them to find their next home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access, made simple.</strong> From your Stonebriar Woods home base, manage the everyday details in just a few clicks—pay rent, submit maintenance requests, and keep your account up to date, then get back to the wooded calm, landscaped courtyards, and trail-connected Overland Park setting you know.</p>",
  "property_reviews_blurb": "<p>Stonebriar Woods Apartment Homes is committed to providing residents, prospective residents, and vendors with an excellent experience. If you’ve lived here, take a moment to share a review; we’d love to hear from you. Read reviews from current and former residents to see what makes Stonebriar Woods Apartment Homes a great place to call home.</p>",
  "property_created_at": "1785792609736",
  "property_scheduletour_blurb": "<p>Ready to see Stonebriar Woods Apartment Homes in person? Schedule a guided tour of our Overland Park, KS apartments and explore available one-, two-, and three-bedroom floor plans, or take a <a href=\"/virtual-tours\">self-guided tour online</a> at your own pace. Review our <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a> before you visit, or <a href=\"/contact-us\">contact us</a> with any questions. Choose a convenient date and time to plan your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we received your inquiry.</strong><br>Stonebriar Woods Apartment Homes’ leasing team will be in touch soon. In the meantime, picture wooded calm in Overland Park with tree-framed views, landscaped courtyards, Indian Creek Trail access, and comfortable one-, two-, and three-bedroom layouts waiting to be explored.</p>",
  "property_virtualtours_blurb": "<p><strong>Let each layout unfold on your screen.</strong> Explore Stonebriar Woods Apartment Homes from anywhere with virtual tours of the Broadmoor and Waldorf one-bedroom apartments, the Wilmington and Drake two-bedroom layouts, the Peabody and Raphael two-bedroom, two-bath homes, and the spacious Fairmont three-bedroom option. Move room by room to compare kitchen flow, living-area proportions, bedroom placement, closet space, in-home laundry, and the balcony or patio connection that can make a floor plan feel right. As you tour, watch for select details that bring the Overland Park setting indoors, from wooded-view moments to upgraded finishes, fireplaces, vaulted ceilings, or built-in work space in certain homes. When a favorite stands out, compare current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> for a closer look.</p>",
  "property_copyright": "2026 All Rights Reserved. Stonebriar Woods Apartment Homes",
  "property_seo_title_home": "Apartments in Overland Park, KS | Stonebriar Woods",
  "property_seo_description_home": "Tour Stonebriar Woods Apartment Homes in Overland Park, KS, featuring 1, 2 & 3-bedroom apartments with resort-style amenities. Schedule a tour today!",
  "property_seo_title_floorplans": "1, 2 & 3-Bed Apartments in Overland Park, KS",
  "property_seo_description_floorplans": "Explore 1, 2 & 3-bedroom floor plans at Stonebriar Woods Apartment Homes in Overland Park, KS, from cozy one-bedrooms to a spacious three-bedroom home.",
  "property_seo_title_amenities": "Pet-Friendly Apartment Amenities in Overland Park",
  "property_seo_description_amenities": "See the pet-friendly amenities at Stonebriar Woods Apartment Homes in Overland Park, KS, from a swimming pool and fitness center to tennis courts.",
  "property_seo_title_gallery": "Photo Gallery | Stonebriar Woods Apartment Homes",
  "property_seo_description_gallery": "Browse photos of Stonebriar Woods Apartment Homes in Overland Park, KS, including apartment interiors, the pool, clubhouse and fitness center.",
  "property_seo_title_virtualtours": "Virtual Tours | Stonebriar Woods Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Step inside Stonebriar Woods in Overland Park, KS! Take a virtual tour of our stunning one, two, and three-bedroom apartments—your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Property Map | Stonebriar Woods",
  "property_seo_description_interactivemap": "Use the interactive property map at Stonebriar Woods Apartment Homes to explore available apartments and floor plans in Overland Park, KS.",
  "property_seo_title_neighborhood": "Apartments Near JCCC in Overland Park, KS",
  "property_seo_description_neighborhood": "Stonebriar Woods Apartment Homes sits minutes from JCCC, Quivira Park and the Indian Creek Trail in Overland Park, KS. Visit us today.",
  "property_seo_title_contact": "Contact Stonebriar Woods Apartment Homes | KS",
  "property_seo_description_contact": "Contact Stonebriar Woods Apartment Homes in Overland Park, KS to ask about floor plans, pricing, availability or scheduling a tour.",
  "property_seo_title_faqs": "FAQs | Stonebriar Woods Apartment Homes",
  "property_seo_description_faqs": "Find answers about applications, pet policies, utilities and maintenance requests at Stonebriar Woods Apartment Homes in Overland Park, KS.",
  "property_seo_title_reviews": "Reviews | Stonebriar Woods Apartment Homes",
  "property_seo_description_reviews": "Read reviews from residents of Stonebriar Woods Apartment Homes in Overland Park, KS and see why renters choose our community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Overland Park, KS",
  "property_seo_description_applynow": "Discover luxury living at Stonebriar Woods in Overland Park, KS. Stunning floor plans and great amenities await—apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Stonebriar Woods Apartment Homes",
  "property_seo_description_residentaccess": "Enhance your Stonebriar Woods living! Log in to the resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Stonebriar Woods Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to Stonebriar Woods in Overland Park! Great friends make the best neighbors—share the love of our community and enjoy exclusive rewards!",
  "property_seo_title_scheduletour": "Schedule a Tour | Stonebriar Woods Apartment Homes",
  "property_seo_description_scheduletour": "Schedule a guided or self-guided tour of Stonebriar Woods Apartment Homes in Overland Park, KS and explore our available floor plans today.",
  "property_seo_title_privacy": "Privacy Policy | Stonebriar Woods Apartment Homes",
  "property_seo_description_privacy": "At Stonebriar Woods in Overland Park, your privacy matters. Read our policy to understand how we protect your information while you enjoy your home.",
  "property_seo_title_accessibility": "Website Accessibility | Stonebriar Woods Apartment Homes",
  "property_seo_description_accessibility": "At Stonebriar Woods in Overland Park, KS, we prioritize accessibility and digital inclusion, ensuring a welcoming home for everyone. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | Stonebriar Woods Apartment Homes",
  "property_seo_description_sitemap": "Uncover hidden gems at Stonebriar Woods in Overland Park, KS. Navigate our sitemap for a detailed overview of your future home and our community offerings!",
  "property_seo_title_thankyou": "Thank You | Stonebriar Woods Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out to Stonebriar Woods in Overland Park! Our team will connect with you soon to help you find your ideal home. Dreams begin here!",
  "property_seo_title_pets": "Pet Policy | Apartments in Overland Park, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793742993759",
  "amenities": [
    {
      "id": "ec_b13358943a4dcf07208c83c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125916",
      "title": "Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b667-d4f9-71aa-8769-491cfb0fec2a.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by trees.",
        "public_id": "01a0b667-d4f9-71aa-8769-491cfb0fec2a",
        "storage_key": "property/6767906449167614/01a0b667-d4f9-71aa-8769-491cfb0fec2a.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "an aerial view of a neighborhood of houses at Stonebriar Woods Apartments, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6da8fe2010850b2a77092cd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "121013114",
      "title": "Carports Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-0446-717a-9ae0-cba038b5be08.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by lush greenery and trees.",
        "public_id": "01a0b668-0446-717a-9ae0-cba038b5be08",
        "storage_key": "property/6767906449167614/01a0b668-0446-717a-9ae0-cba038b5be08.webp",
        "width": 3072,
        "height": 2047
      },
      "amenity_image_alt_text": "Carports Available at Stonebriar Woods Apartments, Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08faf98da430ea7bc3493700",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125904",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b667-d399-7038-857a-a51d2b75d0c4.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of apartment building exterior with pool and tennis courts.",
        "public_id": "01a0b667-d399-7038-857a-a51d2b75d0c4",
        "storage_key": "property/6767906449167614/01a0b667-d399-7038-857a-a51d2b75d0c4.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "an aerial view of a large house with a pool in the backgroundat Stonebriar Woods Apartments, Kansas, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a8c20fd970d516efbfbdb90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125906",
      "title": "State-of-the-Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79acdd22391bb189f8fbd2cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125917",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b667-d392-74da-a759-795ab32f4562.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of a swimming pool and courtyard area at a multifamily property.",
        "public_id": "01a0b667-d392-74da-a759-795ab32f4562",
        "storage_key": "property/6767906449167614/01a0b667-d392-74da-a759-795ab32f4562.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "arial view of a house with a swimming poolat Stonebriar Woods Apartments, Kansas,a large swimming pool in front of a houseat Stonebriar Woods Apartments, Overland Park, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3ac1b70380c06ae53ce2a13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125905",
      "title": "Courtyards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5030778075139c83da164b15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125910",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b667-d564-719e-906d-1ee4d8467efc.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of apartment complex amenities including tennis courts, sand volleyball, and swimming pool.",
        "public_id": "01a0b667-d564-719e-906d-1ee4d8467efc",
        "storage_key": "property/6767906449167614/01a0b667-d564-719e-906d-1ee4d8467efc.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "Tennis Court at Stonebriar Woods Apartment Homes, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f158fd70a7414fcf6ea3789b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125918",
      "title": "Sand Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08f02dd75604127a9c59908a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "121013113",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f54677a87035fc2ed1fde5ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125909",
      "title": "Access to Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2816ea9ec5a0ec487af78d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125907",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ecce192abb33297665b8bb29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125908",
      "title": "On-Call Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aedd77191339a477acdb7ba0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125922",
      "title": "Sun Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e33f8d3dbc2a0308b46618c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125913",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a8-19f6-7581-bce6-45e302198d9d.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of apartment complex building and pool area",
        "public_id": "019ff6a8-19f6-7581-bce6-45e302198d9d",
        "storage_key": "property/6767906449167614/019ff6a8-19f6-7581-bce6-45e302198d9d.webp",
        "width": 3072,
        "height": 2047
      },
      "amenity_image_alt_text": "Beautiful Landscaping at Stonebriar Woods Apartments, Kansas, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ca5d4c19226cfb508c7d43c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125912",
      "title": "Easy Access to Shopping & Freeways",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5878de4e40ab421c277b4916",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125921",
      "title": "Access to Indian Creek Trail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b667-fbab-75f4-8f95-f1d076ae90f6.webp",
      "amenity_image_media": {
        "alt_text": "Couple jogging on a park path surrounded by lush greenery.",
        "public_id": "01a0b667-fbab-75f4-8f95-f1d076ae90f6",
        "storage_key": "property/6767906449167614/01a0b667-fbab-75f4-8f95-f1d076ae90f6.webp",
        "width": 3072,
        "height": 2050
      },
      "amenity_image_alt_text": "a couple jogging in a park at Stonebriar Woods Apartments, Kansas, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c0318f6a9f555a08093056bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125911",
      "title": "Disability Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37fca7c3f3368f33ea571625",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125915",
      "title": "Copy & Fax Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06ab2f3c2215647ecc70761b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "122755398",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0adc59bf917cf09359b5c4ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125932",
      "title": "Washer/Dryer In-Unit",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35802d3e852c65548bd36b1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "121013116",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_184207cee53eadc1e1b440b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125930",
      "title": "Microwave*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d32aa4a94e38601b07559127",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "121013038",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d230b319ddc4a1f62cae172b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125931",
      "title": "Balcony/Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42f76a8aa3f6138123a18f75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125928",
      "title": "Simulated Wood Floors*",
      "amount": "false",
      "description": "*Varying Locations in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b667-e5f3-753c-a889-0c544cf55222.webp",
      "amenity_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen view.",
        "public_id": "01a0b667-e5f3-753c-a889-0c544cf55222",
        "storage_key": "property/6767906449167614/01a0b667-e5f3-753c-a889-0c544cf55222.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Simulated Wood Floors at Stonebriar Woods Apartments, Overland Park, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2f4290a6ef1cd096e94de55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125927",
      "title": "Wood Burning Fireplace*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66c59e94c320d732e12e1101",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125926",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1af7e2372c712d4783c7deb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125924",
      "title": "Ceiling Fan(s)*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b667-ec0a-75d5-8197-d30b384d1dad.webp",
      "amenity_image_media": {
        "alt_text": "Living room and kitchen area of an apartment.",
        "public_id": "01a0b667-ec0a-75d5-8197-d30b384d1dad",
        "storage_key": "property/6767906449167614/01a0b667-ec0a-75d5-8197-d30b384d1dad.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Ceiling Fan(s) at Stonebriar Woods Apartments, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84fba144a67c5247124fd743",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125929",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ce5bfe494412286813a1e96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "121013039",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9dccaea78d5c24db495b5517",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125935",
      "title": "Gourmet Kitchen*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-01eb-72a1-8666-346dbe13a584.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white cabinets, black stove, and white refrigerator.",
        "public_id": "01a0b668-01eb-72a1-8666-346dbe13a584",
        "storage_key": "property/6767906449167614/01a0b668-01eb-72a1-8666-346dbe13a584.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Gourmet Kitchen at Stonebriar Woods Apartments, KS, 66213,Gourmet Kitchen at Stonebriar Woods Apartments, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_210b3f9b8bbca58776100848",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125933",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-2057-77dc-a24d-c2921f77613f.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with stainless steel appliances and a pantry.",
        "public_id": "01a0b668-2057-77dc-a24d-c2921f77613f",
        "storage_key": "property/6767906449167614/01a0b668-2057-77dc-a24d-c2921f77613f.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Stainless Steel Appliances at Stonebriar Woods Apartments, Overland Park, KS, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9320ee070d484afa7b157d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125936",
      "title": "Study*",
      "amount": "false",
      "description": "*in Select Floor Plans",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_326e55f10cae5110aa2f995f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "121428899",
      "title": "Wooded View*",
      "amount": "false",
      "description": "*with Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f285bd19569b051762066425",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88125934",
      "title": "Upgraded Blinds and Finishes*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-12ae-76dd-bd17-5d388932110e.webp",
      "amenity_image_media": {
        "alt_text": "Modern bedroom with a king-size bed, two nightstands, and abstract wall art.",
        "public_id": "01a0b668-12ae-76dd-bd17-5d388932110e",
        "storage_key": "property/6767906449167614/01a0b668-12ae-76dd-bd17-5d388932110e.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Upgraded Blinds and Finishes at Stonebriar Woods Apartments, Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff44bb5ca8adbfadf4aef8a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "external_id": "88146922",
      "title": "Built-In Desk*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_d9134ec971510aafc42a67e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b667-c0b6-711a-bf79-b1ee640a6869.webp",
      "image_media": {
        "alt_text": "Open concept living and dining area with kitchen view.",
        "public_id": "01a0b667-c0b6-711a-bf79-b1ee640a6869",
        "storage_key": "property/6767906449167614/01a0b667-c0b6-711a-bf79-b1ee640a6869.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area with a modern kitchen view, perfect for entertaining and comfortable everyday living.",
      "link": "false",
      "alt_text": "Open concept living and dining area with kitchen view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-12401 W 120th St-12.jpg"
    },
    {
      "id": "ec_89479b31b97ab83dcac3a334",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-58ff-715f-bc00-e3be32e214d6.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, double sink, stainless steel refrigerator, microwave, and stove.",
        "public_id": "01a0b668-58ff-715f-bc00-e3be32e214d6",
        "storage_key": "property/6767906449167614/01a0b668-58ff-715f-bc00-e3be32e214d6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinetry, granite countertops, a stainless steel refrigerator, microwave, and stove. Includes a spacious pantry.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, granite countertops, double sink, stainless steel refrigerator, microwave, and stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-12401 W 120th St-14.jpg"
    },
    {
      "id": "ec_5fd70d75a2c1e81fb93d287b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-570a-7725-8b71-0c82cf43a1e2.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large sectional sofa, coffee table, and entertainment center.",
        "public_id": "01a0b668-570a-7725-8b71-0c82cf43a1e2",
        "storage_key": "property/6767906449167614/01a0b668-570a-7725-8b71-0c82cf43a1e2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this spacious living room, perfect for entertaining guests or enjoying a quiet night in. Features a comfortable sectional sofa and ample space.",
      "link": "false",
      "alt_text": "Spacious living room with a large sectional sofa, coffee table, and entertainment center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-12401 W 120th St-10.jpg"
    },
    {
      "id": "ec_08a07a1855c200afc82344bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-3e80-74c3-9f77-72602cfdb884.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, closet, and TV.",
        "public_id": "01a0b668-3e80-74c3-9f77-72602cfdb884",
        "storage_key": "property/6767906449167614/01a0b668-3e80-74c3-9f77-72602cfdb884.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a comfortable bed, ample closet space, and a wall-mounted television for entertainment.",
      "link": "false",
      "alt_text": "Bedroom with a bed, closet, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-12401 W 120th St-18.jpg"
    },
    {
      "id": "ec_1828ab6b15abbdb7deea7e8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-59bf-7168-a837-dd9109db0054.webp",
      "image_media": {
        "alt_text": "Bedroom with a television on a dresser and an open closet with clothes.",
        "public_id": "01a0b668-59bf-7168-a837-dd9109db0054",
        "storage_key": "property/6767906449167614/01a0b668-59bf-7168-a837-dd9109db0054.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large TV on a modern dresser and a walk-in closet filled with organized clothing and shoes.",
      "link": "false",
      "alt_text": "Bedroom with a television on a dresser and an open closet with clothes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/24-12401 W 120th St-24.jpg"
    },
    {
      "id": "ec_71cc51c58cc63408c27e4d1f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-7d8a-73bd-802a-fc5e5e61944c.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and decor.",
        "public_id": "01a0b668-7d8a-73bd-802a-fc5e5e61944c",
        "storage_key": "property/6767906449167614/01a0b668-7d8a-73bd-802a-fc5e5e61944c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, stylish nightstands, and tasteful wall art. Enjoy a serene and inviting atmosphere.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, nightstands, and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-12401 W 120th St-16.jpg"
    },
    {
      "id": "ec_820a797146a54580f7123fd7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-595e-712c-913c-270b127dac51.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, nightstands, and wall art.",
        "public_id": "01a0b668-595e-712c-913c-270b127dac51",
        "storage_key": "property/6767906449167614/01a0b668-595e-712c-913c-270b127dac51.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, elegant nightstands, and tasteful wall decor. A perfect retreat after a long day.",
      "link": "false",
      "alt_text": "Spacious bedroom with a king-size bed, nightstands, and wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-12401 W 120th St-22.jpg"
    },
    {
      "id": "ec_5bafe92b6f89211b3ee002b2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-81a6-77e9-90ce-a0c3914b90d2.webp",
      "image_media": {
        "alt_text": "Exterior building entrance with brick facade, white columns, and manicured landscaping.",
        "public_id": "01a0b668-81a6-77e9-90ce-a0c3914b90d2",
        "storage_key": "property/6767906449167614/01a0b668-81a6-77e9-90ce-a0c3914b90d2.webp",
        "width": 1140,
        "height": 760
      },
      "title": "Community",
      "description": "Welcome home to this beautiful community entrance, featuring classic brick architecture, elegant columns, and lush greenery for a striking first impression.",
      "link": "false",
      "alt_text": "Exterior building entrance with brick facade, white columns, and manicured landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3SBW-Amenities-8.jpg"
    },
    {
      "id": "ec_3e4586651473bb31c7132c51",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-9872-7473-9467-4a92c02deeac.webp",
      "image_media": {
        "alt_text": "People relaxing by and swimming in an outdoor pool on a sunny day.",
        "public_id": "01a0b668-9872-7473-9467-4a92c02deeac",
        "storage_key": "property/6767906449167614/01a0b668-9872-7473-9467-4a92c02deeac.webp",
        "width": 1152,
        "height": 928
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lounge chairs and lush greenery. Perfect for a sunny day of relaxation.",
      "link": "false",
      "alt_text": "People relaxing by and swimming in an outdoor pool on a sunny day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pool 1.png"
    },
    {
      "id": "ec_4f0b7c8c193c0d29903c753c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-98ad-7669-89fe-48e249b737af.webp",
      "image_media": {
        "alt_text": "People relaxing by and in an outdoor swimming pool.",
        "public_id": "01a0b668-98ad-7669-89fe-48e249b737af",
        "storage_key": "property/6767906449167614/01a0b668-98ad-7669-89fe-48e249b737af.webp",
        "width": 1152,
        "height": 928
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs perfect for soaking up the sun.",
      "link": "false",
      "alt_text": "People relaxing by and in an outdoor swimming pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pool 2.png"
    },
    {
      "id": "ec_328beb2b948c2c43ac1bf321",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-85aa-71ed-8b3c-1c3948fcea62.webp",
      "image_media": {
        "alt_text": "Two people playing tennis on a blue court with apartment buildings in the background.",
        "public_id": "01a0b668-85aa-71ed-8b3c-1c3948fcea62",
        "storage_key": "property/6767906449167614/01a0b668-85aa-71ed-8b3c-1c3948fcea62.webp",
        "width": 1152,
        "height": 928
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle at our community's tennis courts. Perfect for a friendly match or getting some exercise.",
      "link": "false",
      "alt_text": "Two people playing tennis on a blue court with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Tennis Court with People.png"
    },
    {
      "id": "ec_997fc1505536cf38fb1e58ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-8dc6-75ff-a288-b52493ac4113.webp",
      "image_media": {
        "alt_text": "People working out in a modern fitness center with treadmills, elliptical machines, and weightlifting equipment.",
        "public_id": "01a0b668-8dc6-75ff-a288-b52493ac4113",
        "storage_key": "property/6767906449167614/01a0b668-8dc6-75ff-a288-b52493ac4113.webp",
        "width": 848,
        "height": 1264
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully-equipped fitness center, featuring state-of-the-art cardio and weight training equipment for all residents.",
      "link": "false",
      "alt_text": "People working out in a modern fitness center with treadmills, elliptical machines, and weightlifting equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/fitness center with people.png"
    },
    {
      "id": "ec_c0a9d6352efc5e7c9f3de855",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-9224-7369-9bf1-b274c319bc17.webp",
      "image_media": {
        "alt_text": "People playing volleyball on a sand court with apartment buildings in the background.",
        "public_id": "01a0b668-9224-7369-9bf1-b274c319bc17",
        "storage_key": "property/6767906449167614/01a0b668-9224-7369-9bf1-b274c319bc17.webp",
        "width": 1152,
        "height": 928
      },
      "title": "Community",
      "description": "Enjoy a game of beach volleyball with friends and neighbors on our outdoor sand court. The perfect way to stay active and have fun!",
      "link": "false",
      "alt_text": "People playing volleyball on a sand court with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sand Volleyball.png"
    },
    {
      "id": "ec_331cd1c68b29480fec274559",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-ae27-757f-a1ed-8436b6d0cc15.webp",
      "image_media": {
        "alt_text": "Kettlebells with weights 20, 25, 35, and 45 on a shelf in a gym.",
        "public_id": "01a0b668-ae27-757f-a1ed-8436b6d0cc15",
        "storage_key": "property/6767906449167614/01a0b668-ae27-757f-a1ed-8436b6d0cc15.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "A row of kettlebells, ranging from 20 to 45 pounds, are neatly arranged on a shelf in the community fitness center. Perfect for your workout needs.",
      "link": "false",
      "alt_text": "Kettlebells with weights 20, 25, 35, and 45 on a shelf in a gym.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMF491~1(1).JPG"
    },
    {
      "id": "ec_37b908abd64116add095bf4d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-9682-72cb-9d43-404d958faa0e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with green lawn and trees.",
        "public_id": "01a0b668-9682-72cb-9d43-404d958faa0e",
        "storage_key": "property/6767906449167614/01a0b668-9682-72cb-9d43-404d958faa0e.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings set amidst lush green landscaping and mature trees, offering a serene living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with green lawn and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-12401 w 120th st-7.jpg"
    },
    {
      "id": "ec_3e0f2fc903496330ee9656f2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-aab5-7634-8d4e-9f09a8d9c2e3.webp",
      "image_media": {
        "alt_text": "Treadmills and an elliptical machine in a fitness center.",
        "public_id": "01a0b668-aab5-7634-8d4e-9f09a8d9c2e3",
        "storage_key": "property/6767906449167614/01a0b668-aab5-7634-8d4e-9f09a8d9c2e3.webp",
        "width": 1920,
        "height": 2876
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills, an elliptical, and other cardio machines.",
      "link": "false",
      "alt_text": "Treadmills and an elliptical machine in a fitness center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IM59EC~1(1).JPG"
    },
    {
      "id": "ec_6ce7e6da8c4a10fad3dfaa85",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-b79f-740c-ae08-b166cc9e5733.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by lush green trees and a golf course in the distance.",
        "public_id": "01a0b668-b79f-740c-ae08-b166cc9e5733",
        "storage_key": "property/6767906449167614/01a0b668-b79f-740c-ae08-b166cc9e5733.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Discover our apartment community, nestled amidst beautiful green spaces and mature trees, offering a serene living environment with convenient access to nearby amenities.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings surrounded by lush green trees and a golf course in the distance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-12401 w 120th st-11.jpg"
    },
    {
      "id": "ec_34ca78db7fc9d7186e734667",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-a4e7-7710-93df-d95a41240c25.webp",
      "image_media": {
        "alt_text": "Aerial view of a tennis court, beach volleyball court, and swimming pool at a multifamily property.",
        "public_id": "01a0b668-a4e7-7710-93df-d95a41240c25",
        "storage_key": "property/6767906449167614/01a0b668-a4e7-7710-93df-d95a41240c25.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Enjoy active living with our on-site tennis courts, beach volleyball, and a refreshing swimming pool. Perfect for recreation and relaxation.",
      "link": "false",
      "alt_text": "Aerial view of a tennis court, beach volleyball court, and swimming pool at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01_RES~1(1).JPG"
    },
    {
      "id": "ec_e962a7279c6ec42aa423b969",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-a756-76da-bfbd-942a2c6cf332.webp",
      "image_media": {
        "alt_text": "Beach bag filled with sunscreen, towels, drinks, and accessories on a sandy beach.",
        "public_id": "01a0b668-a756-76da-bfbd-942a2c6cf332",
        "storage_key": "property/6767906449167614/01a0b668-a756-76da-bfbd-942a2c6cf332.webp",
        "width": 1203,
        "height": 1308
      },
      "title": "Lifestyle",
      "description": "Pack your essentials for a perfect day at the beach with this stylish tote, complete with sunscreen, refreshing drinks, and handy accessories.",
      "link": "false",
      "alt_text": "Beach bag filled with sunscreen, towels, drinks, and accessories on a sandy beach.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Summer Fun Giveaway Bag.png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a2f8dcc9-a986-40d3-98c4-f35040a58cb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Talk of the Town Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "11922 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Wide-ranging American menu & sizable microbrew selection offered in a casual sports-bar setting.",
      "poi_long_description": "Wide-ranging American menu & sizable microbrew selection offered in a casual sports-bar setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-05fc-702e-b1ca-78bf75a020e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-05fc-702e-b1ca-78bf75a020e8",
        "storage_key": "property/6767906449167614/019ff6a9-05fc-702e-b1ca-78bf75a020e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.talkofthetowngrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11519808852011712913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "talk-of-the-town-grill--bar",
      "poi_latitude": "38.9134106",
      "poi_longitude": "-94.7252605",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-661-9922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1JPRbTqwIcRkQGPyB2V3p8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9696f74b-d872-4d4c-a386-b137fe2e88f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Barley's Kitchen + Tap",
      "poi_type": "Restaurants",
      "poi_address": "11924 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Brewpub offering a full-length upscale American comfort-food menu, global beer list & TV-watching.",
      "poi_long_description": "Brewpub offering a full-length upscale American comfort-food menu, global beer list & TV-watching.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc990-fbac-70ab-8521-c4e81d4ee25d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc990-fbac-70ab-8521-c4e81d4ee25d",
        "storage_key": "property/6767906449167614/019fc990-fbac-70ab-8521-c4e81d4ee25d.webp",
        "width": 999,
        "height": 888
      },
      "poi_business_url": "http://barleyskitchenandtap.com/op/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7369584364347950482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barleys-kitchen--tap",
      "poi_latitude": "38.9133583",
      "poi_longitude": "-94.7257415",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-663-4099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr63MWrTqwIcRkoU7A-8FRmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d7cc8ba0-3d21-4f05-bad8-593a5d0cff39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Sawasdee Thai Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "11838 Quivira Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "Curries, spring rolls & other Thai staples served in a low-key dining room with traditional decor.",
      "poi_long_description": "Curries, spring rolls & other Thai staples served in a low-key dining room with traditional decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0100f-cf50-74ef-8e50-de5b52deadd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100f-cf50-74ef-8e50-de5b52deadd5",
        "storage_key": "property/6767906449167614/01a0100f-cf50-74ef-8e50-de5b52deadd5.webp",
        "width": 1280,
        "height": 708
      },
      "poi_business_url": "http://sawasdeethaiop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5700896036165937418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sawasdee-thai-cuisine",
      "poi_latitude": "38.9137169",
      "poi_longitude": "-94.7242789",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-338-1673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2aXaDMrqwIcRCmkagb2mHU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_0952bb13-2d93-4a9a-9c68-f6680441e46a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Q39 - South",
      "poi_type": "Restaurants",
      "poi_address": "11051 Antioch Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "Casual joint for Kansas City BBQ, burgers, wings and sandwiches made in-house, plus a fireplace.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc989-5dae-7356-b938-351f8d600b8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-5dae-7356-b938-351f8d600b8e",
        "storage_key": "property/6767906449167614/019fc989-5dae-7356-b938-351f8d600b8e.webp",
        "width": 960,
        "height": 543
      },
      "poi_business_url": "https://q39kc.com/locations/overland-park-bbq/?utm_source=Google&utm_medium=Maps&utm_campaign=GBP_south",
      "poi_directions_map_url": "https://maps.google.com/?cid=10944240241970651302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "q39---south",
      "poi_latitude": "38.9287968",
      "poi_longitude": "-94.6857828",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-951-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fk1I1bqwIcRpiAy14PA4Zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_bcf46b0e-4c70-46dc-919c-fc51854a3baf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Ricco's Italian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "11801 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Traditional Italian food & wood-fired pizzas prepared in a quiet setting with a patio lounge.",
      "poi_long_description": "Traditional Italian food & wood-fired pizzas prepared in a quiet setting with a patio lounge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-6d1e-7326-a572-3bcf9e9d6911.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-6d1e-7326-a572-3bcf9e9d6911",
        "storage_key": "property/6767906449167614/01a0b668-6d1e-7326-a572-3bcf9e9d6911.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://riccoskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=26080697992341164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riccos-italian-bistro",
      "poi_latitude": "38.9266442",
      "poi_longitude": "-94.7224104",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-469-8405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9aUv39PqwIcRrOZTs0GoXAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_cfb4bafa-2f78-4d20-a7a3-1af5b6bc3409",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Revel Sports Tavern",
      "poi_type": "Restaurants",
      "poi_address": "7300 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Unfussy sports bar serving American eats such as nachos and tacos, plus happy hour deals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6d2-59f9-76c3-97b7-8670577b0266.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d2-59f9-76c3-97b7-8670577b0266",
        "storage_key": "property/6767906449167614/019ff6d2-59f9-76c3-97b7-8670577b0266.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://revelsportstavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3006978606875420274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "revel-sports-tavern",
      "poi_latitude": "38.9154511",
      "poi_longitude": "-94.6719406",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-242-7791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6d2-75f5-752d-b217-895574af72ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6d2-75f5-752d-b217-895574af72ac",
        "storage_key": "property/6767906449167614/019ff6d2-75f5-752d-b217-895574af72ac.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjymNo0HrwIcRciYCfhzvuik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_f5469958-dcef-4bf9-a9f4-082135e67b4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "The Peanut",
      "poi_type": "Restaurants",
      "poi_address": "12663 Metcalf Ave, Overland Park, KS 66209, USA",
      "poi_short_description": "Sports bar & grill with classic American pub grub such as BLTs & spicy wings as well as drinks.",
      "poi_long_description": "Sports bar & grill with classic American pub grub such as BLTs & spicy wings as well as drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc991-7839-75b0-9caf-e1392dd346f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-7839-75b0-9caf-e1392dd346f3",
        "storage_key": "property/6767906449167614/019fc991-7839-75b0-9caf-e1392dd346f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://peanutmidwest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2276153363687956292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-peanut",
      "poi_latitude": "38.8990944",
      "poi_longitude": "-94.6662929",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-491-0288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL8knm3TqwIcRRF_uuGyFlh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_98f75a96-7c1f-4b11-8dd0-75ded8eb2213",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc993-94e6-732d-b237-2294809aef9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-94e6-732d-b237-2294809aef9d",
        "storage_key": "property/6767906449167614/019fc993-94e6-732d-b237-2294809aef9d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_439428e9-f071-40d0-811f-dfb5fba44ded",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Redrock Canyon Grill",
      "poi_type": "Restaurants",
      "poi_address": "13505 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Easygoing bistro & bar turning out wood-fired rotisserie chicken & Southwest-inspired dishes.",
      "poi_long_description": "Easygoing bistro & bar turning out wood-fired rotisserie chicken & Southwest-inspired dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0100f-f331-7239-923c-0acb83ee4593.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100f-f331-7239-923c-0acb83ee4593",
        "storage_key": "property/6767906449167614/01a0100f-f331-7239-923c-0acb83ee4593.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.redrockcanyongrill.com/locations/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=938507233962655685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "redrock-canyon-grill",
      "poi_latitude": "38.8829467",
      "poi_longitude": "-94.6672726",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-239-0202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtZlOwMLBwIcRxX96W1s_Bg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_229f2159-6a5f-4dac-b28f-30fa0ad51163",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Jack Stack Barbecue - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "9520 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_long_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-0516-74d8-9ad2-c82f051741f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-0516-74d8-9ad2-c82f051741f3",
        "storage_key": "property/6767906449167614/019ff6a9-0516-74d8-9ad2-c82f051741f3.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.jackstackbbq.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=11966261220374441358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-stack-barbecue---overland-park",
      "poi_latitude": "38.9558013",
      "poi_longitude": "-94.6684419",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-385-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTZe4NL7rwIcRjm3zES6zEKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_b67f2152-50af-4563-bf35-7521bf236e56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "SPIN! Pizza",
      "poi_type": "Restaurants",
      "poi_address": "6501 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Hand-tossed pizzas, salads with housemade dressings, plus gelato in a counter-serve setting.",
      "poi_long_description": "Hand-tossed pizzas, salads with housemade dressings, plus gelato in a counter-serve setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0100f-d78c-74f7-9adb-40c4349eb5f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100f-d78c-74f7-9adb-40c4349eb5f4",
        "storage_key": "property/6767906449167614/01a0100f-d78c-74f7-9adb-40c4349eb5f4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.spinpizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5492391185173538158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spin-pizza",
      "poi_latitude": "38.8820731",
      "poi_longitude": "-94.6614847",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-897-7746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH1bakOjBwIcRbmXB167kOEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_4604952c-beec-4365-a42f-98fb465588f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Nick & Jake's Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "6830 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Local bar & grill chain serving classic American fare, pasta, burgers & global bites.",
      "poi_long_description": "Local bar & grill chain serving classic American fare, pasta, burgers & global bites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6d2-561a-7039-b563-559484677a96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d2-561a-7039-b563-559484677a96",
        "storage_key": "property/6767906449167614/019ff6d2-561a-7039-b563-559484677a96.webp",
        "width": 975,
        "height": 1233
      },
      "poi_business_url": "http://www.nickandjakes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1372827290254850032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nick--jakes-overland-park",
      "poi_latitude": "38.8843201",
      "poi_longitude": "-94.6646491",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-681-8535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJexsdCujBwIcR8DeanSVDDRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_563b88e6-28f5-45f6-9cd6-f8bb65e8dab2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Rajadhani Indian Cuisine - Overland Park, Kansas",
      "poi_type": "Restaurants",
      "poi_address": "12030 Blue Valley Pkwy, Overland Park, KS 66213, USA",
      "poi_short_description": "Relaxed Indian restaurant specializing in biryanis and other classics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-6e93-7076-a1a3-f7337661eb99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-6e93-7076-a1a3-f7337661eb99",
        "storage_key": "property/6767906449167614/01a0b668-6e93-7076-a1a3-f7337661eb99.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.rajadhaniks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12703024965761278897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rajadhani-indian-cuisine---overland-park-kansas",
      "poi_latitude": "38.91032209999999",
      "poi_longitude": "-94.6739272",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-232-9422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRYPfRSTrwIcRsaMeIec1SrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a55b424d-2673-4c0a-b5f7-ed97bca0e2ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Veritas Whiskey and Wine Grill",
      "poi_type": "Restaurants",
      "poi_address": "5621 W 135th St Ste 2620, Overland Park, KS 66223, USA",
      "poi_short_description": "Restaurant serving brunch, lunch and dinner alongside craft cocktails and a wine selection.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-6e49-722a-83c6-469e6dce306b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-6e49-722a-83c6-469e6dce306b",
        "storage_key": "property/6767906449167614/01a0b668-6e49-722a-83c6-469e6dce306b.webp",
        "width": 926,
        "height": 806
      },
      "poi_business_url": "http://veritaskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11216570818203659628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "veritas-whiskey-and-wine-grill",
      "poi_latitude": "38.8828245",
      "poi_longitude": "-94.6505221",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-291-0504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8tEd_7BwIcRbK0KMbtDqZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0ef9a82c-d4c5-46fa-be9e-92b5d4faf5c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "JCCC Regnier Center",
      "poi_type": "Education",
      "poi_address": "Regnier Center, College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-71cd-729e-9524-fc6714647ed7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-71cd-729e-9524-fc6714647ed7",
        "storage_key": "property/6767906449167614/01a0b668-71cd-729e-9524-fc6714647ed7.webp",
        "width": 1280,
        "height": 665
      },
      "poi_business_url": "https://www.jccc.edu/about/campus/maps/buildings/rc.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1066640827675886893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jccc-regnier-center",
      "poi_latitude": "38.9243918",
      "poi_longitude": "-94.7265567",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV2OjvdLqwIcRLcWMdC54zQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fe3538e1-9129-4231-a677-75d006552b7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "11902 Riley St, Overland Park, KS 66213, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc990-6f7b-717e-9e5b-fa6ef1a7c67b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc990-6f7b-717e-9e5b-fa6ef1a7c67b",
        "storage_key": "property/6767906449167614/019fc990-6f7b-717e-9e5b-fa6ef1a7c67b.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ks/overland-park/11902-riley-st?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQyNTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5090252718221405687&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "38.9122348",
      "poi_longitude": "-94.6730365",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-469-1836",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-aa52-7234-adc1-ea6c7c3f6a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b668-aa52-7234-adc1-ea6c7c3f6a18",
        "storage_key": "property/6767906449167614/01a0b668-aa52-7234-adc1-ea6c7c3f6a18.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDcpceqjBwIcR962NvuA1pEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_5e28bc29-b647-4f10-9ff6-256fe4f688e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Cosentino's Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "7418 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Supermarket and bakery, plus a salad bar, deli and meat department.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-7087-76bf-8390-3c5dd634c721.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-7087-76bf-8390-3c5dd634c721",
        "storage_key": "property/6767906449167614/01a0b668-7087-76bf-8390-3c5dd634c721.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=79",
      "poi_directions_map_url": "https://maps.google.com/?cid=6582040041124791997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-price-chopper",
      "poi_latitude": "38.9123312",
      "poi_longitude": "-94.6744137",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-338-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c321-7223-8b56-6f2114c34c61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c321-7223-8b56-6f2114c34c61",
        "storage_key": "property/6767906449167614/019fc98a-c321-7223-8b56-6f2114c34c61.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ54NSxGnqwIcRvQakVIsaWFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_67c3a8cc-8f53-479b-9624-0204e2a4ce78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "12200 Blue Valley Pkwy, Overland Park, KS 66213, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc992-6e52-732c-8451-48f46fde27b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-6e52-732c-8451-48f46fde27b5",
        "storage_key": "property/6767906449167614/019fc992-6e52-732c-8451-48f46fde27b5.webp",
        "width": 1280,
        "height": 669
      },
      "poi_business_url": "https://www.target.com/sl/overland-park/1757",
      "poi_directions_map_url": "https://maps.google.com/?cid=6931391453674116315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.9076847",
      "poi_longitude": "-94.6750703",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-327-7770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf28-7665-b4c9-818447df9d96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf28-7665-b4c9-818447df9d96",
        "storage_key": "property/6767906449167614/019fc98a-bf28-7665-b4c9-818447df9d96.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk4-I6W7qwIcR25Rsk80_MWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_c3b87c70-dfee-4348-897f-b953f25ed1c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "12601 South Pflumm Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-0b60-741c-a80f-5ae646de96bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-0b60-741c-a80f-5ae646de96bd",
        "storage_key": "property/6767906449167614/019ff6a9-0b60-741c-a80f-5ae646de96bd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-12601+pflumm+rd-overland+park-ks-66213/id=9424",
      "poi_directions_map_url": "https://maps.google.com/?cid=13356550244999368949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.8989113",
      "poi_longitude": "-94.7415179",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-764-3471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4ePkLCVwIcR9RDYia7_W7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_5d9a6882-73f4-4036-befe-d36ffa2eec15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12691 Antioch Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-0a34-75fc-950e-b7039d87858e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-0a34-75fc-950e-b7039d87858e",
        "storage_key": "property/6767906449167614/019ff6a9-0a34-75fc-950e-b7039d87858e.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/12691-antioch-overland-park-ks-66213/storeid=8585?WT.mc_id=LS_GOOGLE_RX_8585",
      "poi_directions_map_url": "https://maps.google.com/?cid=8009062976100597061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.8989109",
      "poi_longitude": "-94.6848773",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-681-9665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-3ac3-7534-a626-389d4795683e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a9-3ac3-7534-a626-389d4795683e",
        "storage_key": "property/6767906449167614/019ff6a9-3ac3-7534-a626-389d4795683e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV8dKcX7qwIcRRX01ylfoJW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_8c323b5f-43cc-45b5-a75a-e0c92dffe0c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11900 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc989-6004-709f-badb-2a065d71c3e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-6004-709f-badb-2a065d71c3e6",
        "storage_key": "property/6767906449167614/019fc989-6004-709f-badb-2a065d71c3e6.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/overlandpark?utm_source=google&utm_medium=organic&utm_campaign=listings&ref_=US_TRF_ALL_UFG_WFM_FRSOC_1001559",
      "poi_directions_map_url": "https://maps.google.com/?cid=8820485549234904426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "38.9124505",
      "poi_longitude": "-94.6683379",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-663-2951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c321-7223-8b56-6f2114c34c61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c321-7223-8b56-6f2114c34c61",
        "storage_key": "property/6767906449167614/019fc98a-c321-7223-8b56-6f2114c34c61.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz07vMxTqwIcRat2cxN-oaHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fa13f19c-312c-426f-ba87-09418a16be3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "12221 Blue Valley Pkwy, Overland Park, KS 66213, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-0f68-728b-be8a-f113b878f824.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-0f68-728b-be8a-f113b878f824",
        "storage_key": "property/6767906449167614/019ff6a9-0f68-728b-be8a-f113b878f824.webp",
        "width": 1280,
        "height": 518
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/overland-park-KS-369.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12181420978670501186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "38.9065093",
      "poi_longitude": "-94.6707763",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-217-2050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf28-7665-b4c9-818447df9d96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf28-7665-b4c9-818447df9d96",
        "storage_key": "property/6767906449167614/019fc98a-bf28-7665-b4c9-818447df9d96.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg8cveG7qwIcRQn0lFdcZDak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_df019980-5cfe-498f-939d-f48a77f29822",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "8501 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Supermarket with fresh and organic produce as well as a bakery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-7549-70b8-ba9e-07226774f691.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-7549-70b8-ba9e-07226774f691",
        "storage_key": "property/6767906449167614/01a0b668-7549-70b8-ba9e-07226774f691.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=128&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11669836886695708453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.955555",
      "poi_longitude": "-94.683945",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-894-1983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c321-7223-8b56-6f2114c34c61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c321-7223-8b56-6f2114c34c61",
        "storage_key": "property/6767906449167614/019fc98a-c321-7223-8b56-6f2114c34c61.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xEOmOzrwIcRJYc_qtGW86E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d52fc07d-6bae-43c8-bccb-2d3590d802b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Oak Park Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "11149 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_long_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc989-5e6c-777a-9f53-a15824917c24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-5e6c-777a-9f53-a15824917c24",
        "storage_key": "property/6767906449167614/019fc989-5e6c-777a-9f53-a15824917c24.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "https://www.shopoakparkmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751688215534709327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall",
      "poi_latitude": "38.9530939",
      "poi_longitude": "-94.7196254",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-888-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf28-7665-b4c9-818447df9d96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf28-7665-b4c9-818447df9d96",
        "storage_key": "property/6767906449167614/019fc98a-bf28-7665-b4c9-818447df9d96.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzVbG9zXrwIcRTyr3Ao6sEDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3236efff-900e-46a2-9694-57bab365b089",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "LensCrafters",
      "poi_type": "Shopping & Retail",
      "poi_address": "6575 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-7b80-774a-be97-dfb74aabc79f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-7b80-774a-be97-dfb74aabc79f",
        "storage_key": "property/6767906449167614/01a0b668-7b80-774a-be97-dfb74aabc79f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.lenscrafters.com/ks/overland-park/6575-w-119th-st.html?cid=yext_1168&y_source=1_MTIxMDc2Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=494249350429607108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lenscrafters",
      "poi_latitude": "38.9123889",
      "poi_longitude": "-94.6605215",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-696-0191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG4f8KxTqwIcRxATTYirt2wY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_4f858dfd-e75f-450e-a086-6210d24a3e68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Oak Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "10200 W 124th St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-0fae-764f-baf9-6c4849f879ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-0fae-764f-baf9-6c4849f879ef",
        "storage_key": "property/6767906449167614/019ff6a9-0fae-764f-baf9-6c4849f879ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bluevalleyk12.org/ohe",
      "poi_directions_map_url": "https://maps.google.com/?cid=17964561602799488151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-hill-elementary-school",
      "poi_latitude": "38.9046265",
      "poi_longitude": "-94.7042929",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-239-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI_YQc5fqwIcRl0x88JjxTvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_23bf7796-61d4-49f7-91da-3df5d9312a05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Oxford Middle School",
      "poi_type": "Education",
      "poi_address": "12500 Switzer Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-0fab-756b-ba8c-3587e2bd6722.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-0fab-756b-ba8c-3587e2bd6722",
        "storage_key": "property/6767906449167614/019ff6a9-0fab-756b-ba8c-3587e2bd6722.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.bluevalleyk12.org/oms",
      "poi_directions_map_url": "https://maps.google.com/?cid=3089211679266350120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxford-middle-school",
      "poi_latitude": "38.90283",
      "poi_longitude": "-94.706361",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-239-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUbpZ95fqwIcRKKSoqqcV3yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8c3141a3-e48d-4f37-b35e-ad31d9f74b9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Blue Valley Northwest High School",
      "poi_type": "Education",
      "poi_address": "13260 Switzer Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-1265-72cc-818f-c5463f253abe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-1265-72cc-818f-c5463f253abe",
        "storage_key": "property/6767906449167614/019ff6a9-1265-72cc-818f-c5463f253abe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bluevalleyk12.org/bvnw",
      "poi_directions_map_url": "https://maps.google.com/?cid=665158985377803435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-northwest-high-school",
      "poi_latitude": "38.8885806",
      "poi_longitude": "-94.7032351",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-239-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBevbQCHAwIcRq2yaspIeOwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_b7ebef8b-76b7-46d9-b67d-040cf46096ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Overland Trail Middle School",
      "poi_type": "Education",
      "poi_address": "6201 W 133rd St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6d2-5f1a-74cc-8c7b-6fa530ee4302.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d2-5f1a-74cc-8c7b-6fa530ee4302",
        "storage_key": "property/6767906449167614/019ff6d2-5f1a-74cc-8c7b-6fa530ee4302.webp",
        "width": 1280,
        "height": 543
      },
      "poi_business_url": "https://www.bluevalleyk12.org/OTM",
      "poi_directions_map_url": "https://maps.google.com/?cid=15599445353126869038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-trail-middle-school",
      "poi_latitude": "38.8855363",
      "poi_longitude": "-94.6545605",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-239-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJy1sTYGPwIcRLrg-NuZcfNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_1944ee0f-274c-430c-a564-61295dffd6bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "New Horizon Academy",
      "poi_type": "Education",
      "poi_address": "11920 Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0100f-e56a-769e-9a02-9f34306e326d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100f-e56a-769e-9a02-9f34306e326d",
        "storage_key": "property/6767906449167614/01a0100f-e56a-769e-9a02-9f34306e326d.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.newhorizonacademy.net/location/overland-park-ks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17338355438709389589&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-horizon-academy",
      "poi_latitude": "38.91157",
      "poi_longitude": "-94.7244149",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-400-2670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ11iLHg3rwIcRFTm8sWg2nvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_41d84817-b636-4a7f-b459-38ea193ccb39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Ascension Catholic School",
      "poi_type": "Education",
      "poi_address": "9510 W 127th St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-1520-717d-a3f9-0893f1b8ea84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-1520-717d-a3f9-0893f1b8ea84",
        "storage_key": "property/6767906449167614/019ff6a9-1520-717d-a3f9-0893f1b8ea84.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.acseagles.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5112637201567218449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-catholic-school",
      "poi_latitude": "38.8994761",
      "poi_longitude": "-94.6981516",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-851-2531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzYvLQ5vqwIcREXvcaHK880Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2d336a09-5139-44ca-a73e-8c4bf7f8a379",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc989-7123-722c-b4e0-99f9c5da0c57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-7123-722c-b4e0-99f9c5da0c57",
        "storage_key": "property/6767906449167614/019fc989-7123-722c-b4e0-99f9c5da0c57.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a669a4d1-6fdd-486c-bd08-d0c41b4649b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Regents Center",
      "poi_type": "Education",
      "poi_address": "12600 Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc992-5245-74b3-a955-5a207fd96b3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-5245-74b3-a955-5a207fd96b3e",
        "storage_key": "property/6767906449167614/019fc992-5245-74b3-a955-5a207fd96b3e.webp",
        "width": 1280,
        "height": 636
      },
      "poi_business_url": "http://edwardscampus.ku.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17970494846537853263&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regents-center",
      "poi_latitude": "38.8991152",
      "poi_longitude": "-94.724779",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-897-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqe8TXKzqwIcRT2ng5dkFZPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e577dcdf-95a2-4691-8433-fb0fcff30fcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Brookridge Day School",
      "poi_type": "Education",
      "poi_address": "9555 Hadley Dr, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://brookridgedayschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14235491436867488017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookridge-day-school",
      "poi_latitude": "38.9553879",
      "poi_longitude": "-94.6822567",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-649-2228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT8FiwaHrwIcREQma-QmgjsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e5ec2715-1e65-409f-a121-5deb59b39e68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Primrose School of Overland Park",
      "poi_type": "Education",
      "poi_address": "12100 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Warm-looking daycare with a curriculum, clean facilities and educational programs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-7eac-727b-a571-0c426c760a9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-7eac-727b-a571-0c426c760a9f",
        "storage_key": "property/6767906449167614/01a0b668-7eac-727b-a571-0c426c760a9f.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.primroseschools.com/schools/overland-park/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4306267260814237208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-overland-park",
      "poi_latitude": "38.8862853",
      "poi_longitude": "-94.725953",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-400-2435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb1EZGAfAwIcRGB66FELvwjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_f903ffa5-e7d7-4818-ac45-11d1ab7bea14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc989-980c-72dc-923d-8d8bb21a71a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-980c-72dc-923d-8d8bb21a71a4",
        "storage_key": "property/6767906449167614/019fc989-980c-72dc-923d-8d8bb21a71a4.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf38-7748-a8fc-884982ada4b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf38-7748-a8fc-884982ada4b3",
        "storage_key": "property/6767906449167614/019fc98a-bf38-7748-a8fc-884982ada4b3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e0bdaa2c-2e24-49b4-baa8-502b658e140f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc992-b463-7736-9aaf-fc2ae09e8597.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-b463-7736-9aaf-fc2ae09e8597",
        "storage_key": "property/6767906449167614/019fc992-b463-7736-9aaf-fc2ae09e8597.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e667ffb3-12d3-49c3-b0e8-35f2d22d6747",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Overland Park Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8909 W 179th St, Overland Park, KS 66013, USA",
      "poi_short_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_long_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-172a-7662-9a5b-6312336167dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-172a-7662-9a5b-6312336167dc",
        "storage_key": "property/6767906449167614/019ff6a9-172a-7662-9a5b-6312336167dc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/recreation-fun/arboretum-botanical-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713039177416778041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-arboretum--botanical-gardens",
      "poi_latitude": "38.8033925",
      "poi_longitude": "-94.6891159",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-685-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6csjvynHwIcROSH92_fu6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_962acaa5-0301-415f-b99c-38fd8ac374d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "BRKTHROUGH Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "6403 W 135th St Ste E4, Overland Park, KS 66223, USA",
      "poi_short_description": "Social gaming venue at Corbin Park offering mental, physical, and skill-based challenges, plus dining.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-7f5d-749a-b03c-46c98826d593.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-7f5d-749a-b03c-46c98826d593",
        "storage_key": "property/6767906449167614/01a0b668-7f5d-749a-b03c-46c98826d593.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brkthrough.com/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18381408078784845033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brkthrough-overland-park",
      "poi_latitude": "38.8806486",
      "poi_longitude": "-94.659253",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-948-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ45a5JQXBwIcR6VR3P0LhF_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_a68b6cf5-bdf7-48a5-8bfa-15b04926fa0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "AMC Town Center 20",
      "poi_type": "Entertainment",
      "poi_address": "11701 Nall Ave, Leawood, KS 66211, USA",
      "poi_short_description": "Modern cinema equipped with comfy seats, luxury recliners, and a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0100f-e969-76bc-9ce9-df3a347855e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100f-e969-76bc-9ce9-df3a347855e1",
        "storage_key": "property/6767906449167614/01a0100f-e969-76bc-9ce9-df3a347855e1.webp",
        "width": 1280,
        "height": 783
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-town-center-20?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2804340900304979407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-town-center-20",
      "poi_latitude": "38.915838",
      "poi_longitude": "-94.648325",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-498-8696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-3ace-70de-9e0e-ee81870189a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a9-3ace-70de-9e0e-ee81870189a7",
        "storage_key": "property/6767906449167614/019ff6a9-3ace-70de-9e0e-ee81870189a7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xgReh_qwIcRzwXH1zAF6yY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_cfa86438-fc3f-4f18-b74a-2b8e4576384b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "iFLY Indoor Skydiving - Kansas City",
      "poi_type": "Entertainment",
      "poi_address": "10975 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "State-of-the-art wind tunnels are used for indoor skydiving at this family-friendly entertainment center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0100f-ec71-73dc-a796-1b3030055fbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100f-ec71-73dc-a796-1b3030055fbb",
        "storage_key": "property/6767906449167614/01a0100f-ec71-73dc-a796-1b3030055fbb.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.iflyworld.com/kansas-city/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2133132905847574967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ifly-indoor-skydiving---kansas-city",
      "poi_latitude": "38.93024",
      "poi_longitude": "-94.666288",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "100",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-305-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2wSq70nqwIcRt9G9dxNpmh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_887e933b-009c-46ee-be76-e0ce27afa996",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Topgolf Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10611 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc989-77cf-77bb-a80b-283ebfd78587.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-77cf-77bb-a80b-283ebfd78587",
        "storage_key": "property/6767906449167614/019fc989-77cf-77bb-a80b-283ebfd78587.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://topgolf.com/us/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4737452325202402593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-overland-park",
      "poi_latitude": "38.9364597",
      "poi_longitude": "-94.64818",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-562-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf26-75e8-9dbb-1366bf77c6a7",
        "storage_key": "property/6767906449167614/019fc98a-bf26-75e8-9dbb-1366bf77c6a7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibz1RyvqwIcRIZ0JKMrPvkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1472a73f-a787-4084-9b07-a16c9ed58db8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "14401 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc989-9060-72ff-88e6-a8e38036846e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-9060-72ff-88e6-a8e38036846e",
        "storage_key": "property/6767906449167614/019fc989-9060-72ff-88e6-a8e38036846e.webp",
        "width": 909,
        "height": 1186
      },
      "poi_business_url": "https://www.urbanair.com/kansas-overland-park/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=11815076256041431885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "38.8673367",
      "poi_longitude": "-94.664787",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-298-0626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5eXXF5bBwIcRTXOAg0GV96M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_3beef30b-6bea-4a82-9e40-c05a4c3dcc64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Johnson County Arts And Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8788 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Cultural center featuring the Johnson County Museum, the KidScape experience, and a theater.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-80b1-74f9-a218-16d3b0f359da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-80b1-74f9-a218-16d3b0f359da",
        "storage_key": "property/6767906449167614/01a0b668-80b1-74f9-a218-16d3b0f359da.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jcprd.com/327/Arts-Heritage-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6564331375929992564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-arts-and-heritage-center",
      "poi_latitude": "38.9698449",
      "poi_longitude": "-94.6681692",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-826-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2a8po3rwIcRdCVCapswGVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_430552de-2111-4f71-9a35-266486ac11f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Midwest Trust Center",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_long_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc993-80ea-740b-8c76-c903569e6971.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-80ea-740b-8c76-c903569e6971",
        "storage_key": "property/6767906449167614/019fc993-80ea-740b-8c76-c903569e6971.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jccc.edu/midwest-trust-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=333406106616415315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midwest-trust-center",
      "poi_latitude": "38.9252624",
      "poi_longitude": "-94.7279145",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-469-4445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRU0TRZhZ_oAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_c2d6e8da-2e1f-459c-8676-99b0319b2eef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc992-caeb-73f9-97b3-09557819d8df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-caeb-73f9-97b3-09557819d8df",
        "storage_key": "property/6767906449167614/019fc992-caeb-73f9-97b3-09557819d8df.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c312-749e-9d5f-5b8b6c1d4e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c312-749e-9d5f-5b8b6c1d4e17",
        "storage_key": "property/6767906449167614/019fc98a-c312-749e-9d5f-5b8b6c1d4e17.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_f9dfa4ee-ddfd-4876-845b-ee323c4ce66c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc992-c581-74d6-9132-fbaa1005eefd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-c581-74d6-9132-fbaa1005eefd",
        "storage_key": "property/6767906449167614/019fc992-c581-74d6-9132-fbaa1005eefd.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c312-749e-9d5f-5b8b6c1d4e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c312-749e-9d5f-5b8b6c1d4e17",
        "storage_key": "property/6767906449167614/019fc98a-c312-749e-9d5f-5b8b6c1d4e17.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_192e2b92-955d-4d18-bae5-199a1366608e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Carbon Health Urgent Care Overland Park - Hawthorne Plaza",
      "poi_type": "Health and Wellness",
      "poi_address": "4821 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc992-cf34-718c-a853-aa74bb3939b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-cf34-718c-a853-aa74bb3939b1",
        "storage_key": "property/6767906449167614/019fc992-cf34-718c-a853-aa74bb3939b1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://carbonhealth.com/locations/overland-park-hawthorne-plaza?utm_source=gmb&utm_medium=referral&utm_campaign=overland-park&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=16711307106261012561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carbon-health-urgent-care-overland-park---hawthorne-plaza",
      "poi_latitude": "38.91177270000001",
      "poi_longitude": "-94.6412478",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-359-5961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7CzKavpwIcRURAm2UV96uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_ee55e8d1-bcc4-4613-a1c4-652c30732296",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "AdventHealth Centra Care Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "9099 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc992-caec-72aa-be44-c7870fc9d4aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-caec-72aa-be44-c7870fc9d4aa",
        "storage_key": "property/6767906449167614/019fc992-caec-72aa-be44-c7870fc9d4aa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://centracare.adventhealth.com/urgent-care/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16421499770594357393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-centra-care-overland-park",
      "poi_latitude": "38.8832467",
      "poi_longitude": "-94.6909065",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-549-4242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwRwCDLAwIcRkXBvWQnj5OM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_87c9e9cb-a013-4a04-a882-ad9ebd352203",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12601 South Pflumm Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-8291-71ed-9892-63d8e39b3067.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-8291-71ed-9892-63d8e39b3067",
        "storage_key": "property/6767906449167614/01a0b668-8291-71ed-9892-63d8e39b3067.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-12601+pflumm+rd-overland+park-ks-66213/id=9424",
      "poi_directions_map_url": "https://maps.google.com/?cid=14538446860440859119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "38.8988841",
      "poi_longitude": "-94.7415179",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-764-3471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-3ac3-7534-a626-389d4795683e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a9-3ac3-7534-a626-389d4795683e",
        "storage_key": "property/6767906449167614/019ff6a9-3ac3-7534-a626-389d4795683e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCVzdpFuVwIcR73F4PmTwwsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_73bb12ad-d5ad-4610-b13e-c281f9c99e3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "12290 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-8167-7054-9657-153037b9aafa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-8167-7054-9657-153037b9aafa",
        "storage_key": "property/6767906449167614/01a0b668-8167-7054-9657-153037b9aafa.webp",
        "width": 1280,
        "height": 493
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/12290-w-college-blvd-overland-park-ks-66210/storeid=8601?WT.mc_id=LS_GOOGLE_FS_8601",
      "poi_directions_map_url": "https://maps.google.com/?cid=2998230267302422273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "38.92859",
      "poi_longitude": "-94.72835",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-327-1332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt4BBpyyVwIcRAadi9Yramyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_3c1e0819-0ac0-421e-b011-2fc2606d0e7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "6700 W 110th St, Overland Park, KS 66211, USA",
      "poi_short_description": "Tennis and fitness club featuring weight machines, classes and a spa.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc989-95e0-7518-bfa0-7a089dda4d21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-95e0-7518-bfa0-7a089dda4d21",
        "storage_key": "property/6767906449167614/019fc989-95e0-7518-bfa0-7a089dda4d21.webp",
        "width": 867,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/overland-park.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=443534702007543199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genesis-health-clubs---overland-park",
      "poi_latitude": "38.9300809",
      "poi_longitude": "-94.6634864",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-491-4116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKTw7ZzbqwIcRn-W3JnbAJwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f27e1d0e-ef13-4ddb-aec1-c3469ba2796f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "The J KC - Jewish Community Center",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 115th St, Overland Park, KS 66211, USA",
      "poi_short_description": "Fitness facilities featuring an outdoor pool and a children’s zero-depth area, along with summer camps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-8174-70df-875f-d4fd50e4ecb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-8174-70df-875f-d4fd50e4ecb2",
        "storage_key": "property/6767906449167614/01a0b668-8174-70df-875f-d4fd50e4ecb2.webp",
        "width": 1280,
        "height": 644
      },
      "poi_business_url": "https://www.thejkc.org/?utm_source=gbp&utm_medium=organic&utm_id=ifocus",
      "poi_directions_map_url": "https://maps.google.com/?cid=7379659872118781108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-j-kc---jewish-community-center",
      "poi_latitude": "38.9189183",
      "poi_longitude": "-94.6527131",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-327-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtaeWVyLqwIcRtDTY-I3RaWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_65a54375-7477-4015-8e2e-e75cc497f768",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "BODYBAR Pilates - South Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "13340 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "Studio offering Reformer Pilates classes in a supportive environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-8426-7047-b3c3-117511853345.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-8426-7047-b3c3-117511853345",
        "storage_key": "property/6767906449167614/01a0b668-8426-7047-b3c3-117511853345.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bodybarpilates.com/studios/south-overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11674532637011088714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bodybar-pilates---south-overland-park",
      "poi_latitude": "38.8861138",
      "poi_longitude": "-94.6691952",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-907-0904",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwQBFDgDBwIcRShXAO5RFBKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_8303da31-a6e4-40d7-88ad-749791a87fff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Overland Park CrossFit",
      "poi_type": "Health and Wellness",
      "poi_address": "8303 W 126th St B, Overland Park, KS 66213, USA",
      "poi_short_description": "Friendly gym outfitted with new equipment and led by personable coaches, plus classes and coaching for all skill levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-83b1-70dc-b64d-abf4deb90f6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-83b1-70dc-b64d-abf4deb90f6a",
        "storage_key": "property/6767906449167614/01a0b668-83b1-70dc-b64d-abf4deb90f6a.webp",
        "width": 1280,
        "height": 784
      },
      "poi_business_url": "http://www.overlandparkcrossfit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13233065890056778571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-crossfit",
      "poi_latitude": "38.89945609999999",
      "poi_longitude": "-94.6829639",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-735-5167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWfDqJnzqwIcRSzMsslBLpbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a6c25e4c-2db1-4cae-bd30-cf5f2ec26609",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Thomas S. Stoll Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12500 W 119th St, Overland Park, KS 66210, USA",
      "poi_short_description": "Public 79-acre park with 7 ball fields, a fishing lake, a playground & a scenic nature trail.",
      "poi_long_description": "Public 79-acre park with 7 ball fields, a fishing lake, a playground & a scenic nature trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc993-3277-7182-9caf-9f24ce91e989.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-3277-7182-9caf-9f24ce91e989",
        "storage_key": "property/6767906449167614/019fc993-3277-7182-9caf-9f24ce91e989.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jcprd.com/parks_facilities/stoll_park.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=11904290777782419563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thomas-s-stoll-memorial-park",
      "poi_latitude": "38.9133269",
      "poi_longitude": "-94.7313061",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-438-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf32-77ba-a1f7-48fe05b45471",
        "storage_key": "property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06uvXjSVwIcRawCuCGSJNKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_796769f4-7efc-4789-ad18-587d95c15ac2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Quivira Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11901 Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "Small community park featuring a playground, picnic tables & 2 sand volleyball courts.",
      "poi_long_description": "Small community park featuring a playground, picnic tables & 2 sand volleyball courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-1b0a-701e-8607-4ffa19c24cb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-1b0a-701e-8607-4ffa19c24cb6",
        "storage_key": "property/6767906449167614/019ff6a9-1b0a-701e-8607-4ffa19c24cb6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17176832562132200599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quivira-park",
      "poi_latitude": "38.9107813",
      "poi_longitude": "-94.7229342",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf32-77ba-a1f7-48fe05b45471",
        "storage_key": "property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmbS_K7TqwIcRl6xAYDVeYO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_73559786-c8bf-4604-a09a-7bf464f0ac97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Forest Park Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13112 W 125th St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-2718-749b-af3c-ffc70a959af7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-2718-749b-af3c-ffc70a959af7",
        "storage_key": "property/6767906449167614/019ff6a9-2718-749b-af3c-ffc70a959af7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8343077164021621926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forest-park-trailhead",
      "poi_latitude": "38.902893",
      "poi_longitude": "-94.7396689",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-3afd-77d9-bde4-739a9e881ea6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a9-3afd-77d9-bde4-739a9e881ea6",
        "storage_key": "property/6767906449167614/019ff6a9-3afd-77d9-bde4-739a9e881ea6.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJg3fgkqiVwIcRpqQuJ3qQyHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_668fab18-7b6e-4bf1-996f-0250d586690b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Corporate Woods Founders Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9300 Indian Creek Pkwy, Overland Park, KS 66210, USA",
      "poi_short_description": "Recreational park featuring forested trails, a splash fountain & an open field for picnics & events.",
      "poi_long_description": "Recreational park featuring forested trails, a splash fountain & an open field for picnics & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-8741-74f3-a236-9c9b2bc38b43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-8741-74f3-a236-9c9b2bc38b43",
        "storage_key": "property/6767906449167614/01a0b668-8741-74f3-a236-9c9b2bc38b43.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/park/corporate-woods-founders-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14583573077730300202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corporate-woods-founders-park",
      "poi_latitude": "38.933341",
      "poi_longitude": "-94.6949701",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf32-77ba-a1f7-48fe05b45471",
        "storage_key": "property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05niK_3qwIcRKpEQdnJCY8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_47466c6c-f4e2-43ef-93a4-bb590001232f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Roe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10400 Roe Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "40-acre green space boasting a swimming pool, sports courts, a playground & hiking/biking trails.",
      "poi_long_description": "40-acre green space boasting a swimming pool, sports courts, a playground & hiking/biking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc989-d852-7377-9f66-c4b494356415.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-d852-7377-9f66-c4b494356415",
        "storage_key": "property/6767906449167614/019fc989-d852-7377-9f66-c4b494356415.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/park/roe-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5745814544235702059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roe-park",
      "poi_latitude": "38.939606",
      "poi_longitude": "-94.6420669",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-895-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf32-77ba-a1f7-48fe05b45471",
        "storage_key": "property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHWhkHX_pwIcRKydxpuI7vU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9d96b2d5-cccd-4e5e-b43a-8cd78e5cc78f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Nall Hills Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5501 Indian Creek Dr, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-8d13-73e0-aaae-3647930b0101.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-8d13-73e0-aaae-3647930b0101",
        "storage_key": "property/6767906449167614/01a0b668-8d13-73e0-aaae-3647930b0101.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/park/nall-hills-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15640790860681485836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nall-hills-park",
      "poi_latitude": "38.938963",
      "poi_longitude": "-94.651414",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf32-77ba-a1f7-48fe05b45471",
        "storage_key": "property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_3cm1f7rwIcRDJ4YWWtAD9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_841b88fb-d3bd-4099-8cae-d7d44034a2e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Scheels Overland Park Soccer Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13700 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-8923-75c8-982a-b32ee7b6f930.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-8923-75c8-982a-b32ee7b6f930",
        "storage_key": "property/6767906449167614/01a0b668-8923-75c8-982a-b32ee7b6f930.webp",
        "width": 1280,
        "height": 894
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/soccer-complex/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3095772957620985062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scheels-overland-park-soccer-complex",
      "poi_latitude": "38.8802627",
      "poi_longitude": "-94.7045196",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-685-1512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9T6_zzAwIcR5lxCVBpl9io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_14bdfb7a-80d0-4241-819f-ae7520599b27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Regency Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14800 Lamar Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Playground, swings and slides at this chill park featuring a lake and walking paths.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc993-452c-76dc-905a-06f42bb46ccb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-452c-76dc-905a-06f42bb46ccb",
        "storage_key": "property/6767906449167614/019fc993-452c-76dc-905a-06f42bb46ccb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15463142209822193210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regency-lake-park",
      "poi_latitude": "38.8596074",
      "poi_longitude": "-94.6614219",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf32-77ba-a1f7-48fe05b45471",
        "storage_key": "property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQkARJnBwIcROvbMn-kdmNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6029cf76-4546-45df-a344-81e2bd4e0827",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Rosana Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "7500 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Shopping center with a variety of stores and a large parking lot.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-8a61-70ef-9316-b677a37ae750.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-8a61-70ef-9316-b677a37ae750",
        "storage_key": "property/6767906449167614/01a0b668-8a61-70ef-9316-b677a37ae750.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16724846456080379668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosana-square",
      "poi_latitude": "38.9151142",
      "poi_longitude": "-94.6741653",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf28-7665-b4c9-818447df9d96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf28-7665-b4c9-818447df9d96",
        "storage_key": "property/6767906449167614/019fc98a-bf28-7665-b4c9-818447df9d96.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJT_5K7GnqwIcRFC-fYT2XGug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6fda7cee-40d6-40a6-96c0-1be24d4d2135",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Oak Park Mall Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13146997606835839132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park-and-ride",
      "poi_latitude": "38.954938",
      "poi_longitude": "-94.715914",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6d2-7603-714f-80ef-37992e57c9c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6d2-7603-714f-80ef-37992e57c9c6",
        "storage_key": "property/6767906449167614/019ff6d2-7603-714f-80ef-37992e57c9c6.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJv9bmcDjrwIcRnGBc6qqEc7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_96f117b5-11e4-4b99-b77c-24c3e6caba6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-3acd-7464-850b-679259d4acc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a9-3acd-7464-850b-679259d4acc4",
        "storage_key": "property/6767906449167614/019ff6a9-3acd-7464-850b-679259d4acc4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_0b88993c-4d35-4f48-8cc8-d3a5fd48b1ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Johnson County Motor Vehicle",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6000 Lamar Ave, Mission, KS 66202, USA",
      "poi_short_description": "Department of motor vehicles offering services such as vaccines and tax payments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-8dfb-76cc-806a-0c05a1e79f47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-8dfb-76cc-806a-0c05a1e79f47",
        "storage_key": "property/6767906449167614/01a0b668-8dfb-76cc-806a-0c05a1e79f47.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jocogov.org/dept/treasury-and-financial-management/vehicle-tags-and-titling/vehicle-registration",
      "poi_directions_map_url": "https://maps.google.com/?cid=1824756597893120388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-motor-vehicle",
      "poi_latitude": "39.0196656",
      "poi_longitude": "-94.6596799",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-826-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-3b01-70ff-86eb-a8f1af76f456.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a9-3b01-70ff-86eb-a8f1af76f456",
        "storage_key": "property/6767906449167614/019ff6a9-3b01-70ff-86eb-a8f1af76f456.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUoCTjPswIcRhEH4MnXWUhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_25348d5d-a476-4d08-b01b-a99e83a5b16a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc993-ac06-734f-ae36-6c48a4bedb7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-ac06-734f-ae36-6c48a4bedb7b",
        "storage_key": "property/6767906449167614/019fc993-ac06-734f-ae36-6c48a4bedb7b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "38.8",
      "poi_walking_minutes": "14 hours 25 mins",
      "poi_biking_minutes": "4 hours 17 mins",
      "poi_driving_minutes": "38 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-cda3-7247-aa6f-7af9068db0d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-cda3-7247-aa6f-7af9068db0d4",
        "storage_key": "property/6767906449167614/019fc98a-cda3-7247-aa6f-7af9068db0d4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_c1bf3b38-f605-4dbc-9844-7a0f2c0a39f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a01010-01fd-76bd-b2b2-9c2e1f781b3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-01fd-76bd-b2b2-9c2e1f781b3f",
        "storage_key": "property/6767906449167614/01a01010-01fd-76bd-b2b2-9c2e1f781b3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "16.8",
      "poi_walking_minutes": "6 hours 13 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a01010-0b94-752c-90a1-5fd6d7a239c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01010-0b94-752c-90a1-5fd6d7a239c1",
        "storage_key": "property/6767906449167614/01a01010-0b94-752c-90a1-5fd6d7a239c1.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_a18a4122-552f-414a-a00e-7baf48346b4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1101 Troost Ave, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0100f-f97a-74eb-990b-219d521ab398.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100f-f97a-74eb-990b-219d521ab398",
        "storage_key": "property/6767906449167614/01a0100f-f97a-74eb-990b-219d521ab398.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/kansas-city-mo/kansas-city-bus-station?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16685443334022975407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "39.1000335",
      "poi_longitude": "-94.5693013",
      "poi_miles_from_property": "18.5",
      "poi_walking_minutes": "6 hours 52 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWy-YvXvwwIcRr09ZHE-ajuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_4a33ae11-db57-4ca3-a977-206de0bdb83a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "T-Mobile Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6220 Sprint Pkwy, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-242f-746e-aca4-20b61bf729a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-242f-746e-aca4-20b61bf729a7",
        "storage_key": "property/6767906449167614/019fc98a-242f-746e-aca4-20b61bf729a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16065491002476993060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-corporate-office",
      "poi_latitude": "38.9149922",
      "poi_longitude": "-94.6573794",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 855-977-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0P_xjzrwIcRJBrguPIW9N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4bb0f9ba-fb45-44d8-8dd5-cfd874039972",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Children's Mercy Kansas",
      "poi_type": "Health and Wellness",
      "poi_address": "5808 W 110th St, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc989-bc99-709c-9076-3d8b8c62d1c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-bc99-709c-9076-3d8b8c62d1c0",
        "storage_key": "property/6767906449167614/019fc989-bc99-709c-9076-3d8b8c62d1c0.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.childrensmercy.org/Kansas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8535209985424805612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-kansas",
      "poi_latitude": "38.9299718",
      "poi_longitude": "-94.6522904",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-696-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c312-749e-9d5f-5b8b6c1d4e17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c312-749e-9d5f-5b8b6c1d4e17",
        "storage_key": "property/6767906449167614/019fc98a-c312-749e-9d5f-5b8b6c1d4e17.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ03Xo8C7qwIcR7M6coEIoc3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2868aa97-9928-4328-9a5e-8969e2003ab7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-06de-732d-82bb-9e03c7c05bcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-06de-732d-82bb-9e03c7c05bcd",
        "storage_key": "property/6767906449167614/019fc98a-06de-732d-82bb-9e03c7c05bcd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8965e537-cb2c-45e8-bfcd-256b4a664fbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc993-f506-7182-9270-a3f98a65f0f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-f506-7182-9270-a3f98a65f0f1",
        "storage_key": "property/6767906449167614/019fc993-f506-7182-9270-a3f98a65f0f1.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf2e-724c-b00b-a18755604961",
        "storage_key": "property/6767906449167614/019fc98a-bf2e-724c-b00b-a18755604961.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_2ae80e90-6d87-4fc5-af5a-aabda1faeeea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Blue Valley School District Office #229",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15020 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12406361877646761667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-school-district-office-229",
      "poi_latitude": "38.8566433",
      "poi_longitude": "-94.6685552",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-239-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-c315-74a4-b950-9212e3454c53",
        "storage_key": "property/6767906449167614/019fc98a-c315-74a4-b950-9212e3454c53.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkUYMDKHBwIcRw14VYGVALKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3692bf85-110c-49b8-a615-d874d8b5fe96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "Overland Park City Hall",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8500 Santa Fe Dr, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-284c-727b-bec4-6c41d1391dc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-284c-727b-bec4-6c41d1391dc9",
        "storage_key": "property/6767906449167614/019ff6a9-284c-727b-bec4-6c41d1391dc9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/park/city-hall-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10640252352095117489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-city-hall",
      "poi_latitude": "38.97448380000001",
      "poi_longitude": "-94.6854831",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-bf32-77ba-a1f7-48fe05b45471",
        "storage_key": "property/6767906449167614/019fc98a-bf32-77ba-a1f7-48fe05b45471.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdh8t4HrwIcRseAkxyPFqZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bfc57eb4-939d-4bad-8d59-ed49e1dd46ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "poi_name": "OptumRx Fulfillment",
      "poi_type": "Health and Wellness",
      "poi_address": "6800 W 115th St suite 600, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-9615-705d-ac48-528516029db4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b668-9615-705d-ac48-528516029db4",
        "storage_key": "property/6767906449167614/01a0b668-9615-705d-ac48-528516029db4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9191309365621035853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "optumrx-fulfillment",
      "poi_latitude": "38.9190643",
      "poi_longitude": "-94.662952",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/019ff6a9-3ac3-7534-a626-389d4795683e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a9-3ac3-7534-a626-389d4795683e",
        "storage_key": "property/6767906449167614/019ff6a9-3ac3-7534-a626-389d4795683e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSlrPD_qwIcRTROQnisXjn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    }
  ],
  "office_hours": [
    {
      "id": "ec_68f038dd44cf21fd02e58854",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_024dff3dafbc14041f94e353",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0d87b9ed62ced53427671566",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ab65a2d48eef4b242f8d24a2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5cdc644cd588eae44c549a62",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_96b86e750b1dcd0895469f6c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_9a03cc8e-4cc8-4982-b9c1-d4ff2ffffa46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "rating": "4.0",
      "name": "David Alao",
      "text": "It is a quiet community.It is pet friendly, although I am not pet enthusiastic.My family is still navigating the environment about waste disposal and postal services.No microwave is provided for our own unit but we are happy to have washer and dryer in place.Evergy has provided electric power supply before we moved in.Spectrum TV and Internet services are also available.Overall,we look forward to having a safe and comfortable abode in this place.",
      "date": "2026-06-23",
      "title": ""
    },
    {
      "id": "custom_943b93ff-13ed-4602-9417-3bdc2b2bc843",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "rating": "5",
      "name": "Triangulum",
      "text": "Stonebriar Woods has been a wonderful and safe, well maintained and inviting home for myself, father, and partner, Kacie 🦜 for several years. Within walking distance to Johnson County Community College, Stohl Park, a wonderful family-run 7/Eleven store, and animal clinics. Friendly neighbors, good vibes. ✌️ A great place to call home. …",
      "date": "2026-10-27",
      "title": "false"
    },
    {
      "id": "custom_01faaf67-5d4a-43ea-9d38-662baf285c8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "rating": "5",
      "name": "Rika Michelsen",
      "text": "I have lived here for over 20 years. It is my home. I love it and you will too. Abby has been in the office for over half that time and I enjoy visiting her and having coffee. My favorite part of my home is the tree view for me and my dog Brody!",
      "date": "2026-10-25",
      "title": "false"
    },
    {
      "id": "custom_0d86ad2a-2ed3-42a4-947f-173f1e8c3678",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "rating": "4",
      "name": "Nancy R",
      "text": "Management at Stonebriar Woods is excellent.  They are always so willing to help and are very pleasant & caring.  Maintenance is also excellent.  The teams are always quick to fix the issue & very professional.",
      "date": "2026-10-25",
      "title": "false"
    },
    {
      "id": "custom_144d1d3e-ec16-44b5-9487-df05f840b04d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "rating": "5",
      "name": "Missy Cline",
      "text": "Absolutely amazing help from Abby and Alena. Very helpful and professional and walked me through the whole process!",
      "date": "2026-10-21",
      "title": "false"
    },
    {
      "id": "custom_cc8b22a8-ef0b-42c4-bfe9-f26bc792a481",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "rating": "5",
      "name": "Haleena N-S",
      "text": "I’ve rented from quite a few places over the years. Not only has Price Brothers overall been pleasant to work with, but the crew at StoneBriar Woods is amazing.  I work with Aveonna the most. She astounds me with her superior level of customer service. 10/10 would recommend.",
      "date": "2026-10-03",
      "title": "false"
    },
    {
      "id": "custom_be1f2bb6-04ac-4a6d-80d5-930587179bfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "rating": "4",
      "name": "Nolan Jackson",
      "text": "I’ve been living here for two years now. It has been great. My wife and I love the community and when we have any issues or concerns the office staff has been great with communication as well as maintenance.\n",
      "date": "2026-10-02",
      "title": "false"
    },
    {
      "id": "custom_03306ed9-e882-4e65-82e4-3bbe5ba25774",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "rating": "5",
      "name": "Kyleigh Wilson",
      "text": "I went in to see what they had available and the staff was great and answered all the questions I had!\n",
      "date": "2026-09-30",
      "title": "false"
    },
    {
      "id": "custom_f9eeb983-7ef5-4343-8de3-47f33ccd0b55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "rating": "5",
      "name": "Cheryl Word",
      "text": "Great place to live. Staff is always friendly and very helpful.",
      "date": "2026-07-03",
      "title": "false"
    },
    {
      "id": "custom_aa0d4e6c-80ff-43d2-a235-1dcdfbe61d94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "rating": "5",
      "name": "Allison Boister",
      "text": "I have absolutely loved living here. The apartment is big and the agents are wonderful! I would highly recommend checking these out if you are looking to rent an apartment.",
      "date": "2026-06-03",
      "title": "false"
    },
    {
      "id": "custom_acefe3a6-d334-4013-a110-bbb438b5f68d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "rating": "5",
      "name": "Patty Brewster",
      "text": "I I have lived here for 9 years and find the staff helpful and warm-.  All my questions are always answered and everyone is so kind.\n",
      "date": "2026-04-03",
      "title": "false"
    },
    {
      "id": "custom_585c6a8e-e6c8-4433-a505-660bebae6aa3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "rating": "5",
      "name": "Ronald Ruby",
      "text": "The staff at Stonebriar Woods did an amazing job with working with me. Aveonna went above and beyond to help me! I have never had management ever go above and beyond like Stonebriar Woods!\n",
      "date": "2026-03-03",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_5e0cd6ce6c8344021447293a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b669-0364-7722-a81d-1eeb7e5b9597.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b669-0364-7722-a81d-1eeb7e5b9597",
        "storage_key": "property/6767906449167614/01a0b669-0364-7722-a81d-1eeb7e5b9597.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Broadmoor",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vK6quycmkyk"
    },
    {
      "id": "ec_d4a84231d345866a7aa48fcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b669-02ca-73ee-af42-6e89abd32295.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b669-02ca-73ee-af42-6e89abd32295",
        "storage_key": "property/6767906449167614/01a0b669-02ca-73ee-af42-6e89abd32295.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Waldorf",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=d2fimdrke3f"
    },
    {
      "id": "ec_8b029cb7f6dd3292b5358dcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b668-fff5-7495-b1df-257089d9eb2a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b668-fff5-7495-b1df-257089d9eb2a",
        "storage_key": "property/6767906449167614/01a0b668-fff5-7495-b1df-257089d9eb2a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Wilmington",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hHt45n7EEPT"
    },
    {
      "id": "ec_6c3c99f528ae6b85dd9fb96f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b669-0adf-73a9-81b1-f347788bab85.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b669-0adf-73a9-81b1-f347788bab85",
        "storage_key": "property/6767906449167614/01a0b669-0adf-73a9-81b1-f347788bab85.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Drake",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FgFRQcsRizL"
    },
    {
      "id": "ec_bff1365aa4a0fe30bcacbc1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b669-0084-7480-b587-ceca7c01c397.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b669-0084-7480-b587-ceca7c01c397",
        "storage_key": "property/6767906449167614/01a0b669-0084-7480-b587-ceca7c01c397.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Peabody",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iXU6vNvgRHk"
    },
    {
      "id": "ec_b43111c8c236673b8628974f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b669-1a2d-726a-be2a-6a35dd34327e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b669-1a2d-726a-be2a-6a35dd34327e",
        "storage_key": "property/6767906449167614/01a0b669-1a2d-726a-be2a-6a35dd34327e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Raphael",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FfjjJm5oEid"
    },
    {
      "id": "ec_2325e3355de61e9cae9c871c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167614/01a0b669-1e6d-72e9-bf71-68431cb888d5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b669-1e6d-72e9-bf71-68431cb888d5",
        "storage_key": "property/6767906449167614/01a0b669-1e6d-72e9-bf71-68431cb888d5.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Fairmont",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=TUGftdzTfzs"
    }
  ],
  "faqs": [
    {
      "id": "custom_37305bcf-7ffc-4eba-a573-2bbd7211331b",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_07a1a9db-ce8d-4c10-8c9f-82a8daae3775",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_e3ef976b-9db7-4835-b501-0e47459d0ecd",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_5f7e90db-62b1-4c4d-824d-c6f3d9679582",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c6ddeec9-656a-4c97-9e8b-30333a51a726",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_7641767a-a039-4782-8e38-91cf5f688485",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_84476ad1-c3bb-4d8c-9573-7ad590cd25dd",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_404eb01b-3aea-48ef-a29b-d12a431e0f9e",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, sewer, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_3bc3fcf8-2ed9-41e7-8d2c-b22d42f8f6cb",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_46677c0c-eeca-41f1-a3a4-e7c6160d26ae",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_72e5756d-8274-4f82-be9b-0a9b39a0ba4d",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_8357e751-afa3-406c-9b06-44363a885f9b",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_8b0a3511-80c6-492b-b285-9e82b9152629",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer carports and detached garages. Please <a href=\"/contact-us\">contact the office</a> for our most current pricing and availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_bc1c0421-34c3-401c-9213-120ebdaca766",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_2e85a02a-683f-49d6-aca6-9d2498b25c1c",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_2731cb15-426a-4cca-9909-b42f936069e9",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-4591-7335-87a9-6d694777f2e7",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Stonebriar Woods Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614"
    },
    {
      "lead_collector_id": "01a0c9ac-4624-706f-ad03-05240d5e3ab2",
      "lead_source": "LANDING_PAGE",
      "name": "Stonebriar Woods Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "luxury-apartments-in-unit-washer-dryer-op",
      "search_query": "luxury apartments with in-unit washer dryer in Overland Park",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Washer Dryer",
      "h2_subtitle": "Experience luxury living in Overland Park with in-unit washer and dryer amenities at Stonebriar Woods. Discover our upscale, serene community today.",
      "page_copy": "Discover the epitome of elegance at Stonebriar Woods Apartment Homes, where luxury apartments with in-unit washer dryer await in Overland Park. Nestled amidst a tranquil, wooded setting, our community offers one-, two-, and three-bedroom homes that combine comfort with convenience. Enjoy modern features, including stainless steel appliances and built-in bookshelves, enhancing your everyday life.\n\nLocated in Johnson County's highly desirable Regent's Crest neighborhood, Stonebriar Woods provides effortless access to both nature and urban conveniences. With direct access to Indian Creek Trail and proximity to public transportation, our homes offer the best of Overland Park living. Come see for yourself by scheduling a tour today and partake in the Stonebriar Woods experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonebriar Luxury Apartments with In-Unit Laundry",
      "seo_description": "Discover luxury apartments in Overland Park with in-unit washer dryer. Enjoy modern living at Stonebriar Woods. Schedule a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "poolside-apartments-near-indian-creek-trail",
      "search_query": "poolside apartments near Indian Creek Trail",
      "category": "Amenity",
      "h1_title": "Poolside Apartments Near Indian Creek Trail",
      "h2_subtitle": "Enjoy poolside living near Indian Creek Trail at Stonebriar Woods. Experience serene surroundings and modern amenities in Overland Park.",
      "page_copy": "Stonebriar Woods Apartment Homes offers you the ultimate in poolside relaxation and outdoor adventure, with direct access to the scenic Indian Creek Trail. Choose from our array of one-, two-, and three-bedroom apartments, where comfort meets nature. Our homes are equipped with modern amenities including stainless steel appliances and built-in bookshelves, perfect for creating a cozy yet functional living space.\n\nSituated in Overland Park's tranquil Regent's Crest neighborhood, Stonebriar Woods harmoniously blends connectivity and tranquility. Whether it's a leisurely day by the pool or a bike ride along the trail, you will find everything you need right outside your door. Dive into our community experience and enhance your lifestyle by scheduling a tour of our poolside paradise today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Poolside Living at Stonebriar Woods Apartments",
      "seo_description": "Find poolside apartments near Indian Creek Trail at Stonebriar Woods. Enjoy serene living with modern amenities in Overland Park. Schedule a visit!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-johnson-county-trails",
      "search_query": "dog-friendly apartments in Johnson County with access to trails",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with Trail Access",
      "h2_subtitle": "Discover dog-friendly living in Johnson County with trail access. Stonebriar Woods offers the perfect home for you and your furry companion.",
      "page_copy": "Welcome to Stonebriar Woods Apartment Homes, where your four-legged family members are always welcome. Located in the heart of Johnson County, our dog-friendly apartments provide direct access to Indian Creek Trail, making it the perfect place for both you and your pet to explore the outdoors. Choose from our selection of spacious one-, two-, and three-bedroom apartments, complete with modern amenities and a welcoming environment.\n\nOur community, nestled in the serene Regent's Crest neighborhood, combines the luxury of nature with the convenience of suburban living. Stainless steel appliances, built-in bookshelves, and access to public transportation enhance your living experience. Embrace the comfort of Stonebriar Woods, where you and your pet will feel right at home. Schedule a tour today to see why our trail-connected community is ideal for pet lovers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Johnson County Dog-Friendly Apartments with Trails",
      "seo_description": "Explore dog-friendly apartments in Johnson County with trail access at Stonebriar Woods. Perfect living for you and your pet. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-modern-fitness-center-regents-crest",
      "search_query": "apartments with modern fitness center in Regent's Crest",
      "category": "Amenity",
      "h1_title": "Apartments with Modern Fitness Center",
      "h2_subtitle": "Live in Regent's Crest with a modern fitness center at Stonebriar Woods. Enjoy a lifestyle of health and convenience in Overland Park.",
      "page_copy": "Stonebriar Woods Apartment Homes, located in the charming neighborhood of Regent's Crest, offers exceptional living with a modern fitness center at your doorstep. Our one-, two-, and three-bedroom apartments are designed for those who appreciate both luxury and convenience. Enjoy the benefits of a healthy lifestyle in our state-of-the-art fitness center, complemented by comfortable in-home amenities such as stainless steel appliances and built-in bookshelves.\n\nBeyond the fitness center, our community provides direct access to Indian Creek Trail, ideal for outdoor activities and embracing nature. Situated in Overland Park, Stonebriar Woods offers a serene escape with all the conveniences of urban life, including access to public transportation. Experience the perfect blend of wellness and living by scheduling a tour to see Stonebriar Woods firsthand. Discover how our community supports your health goals and lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Regent's Crest Apartments with Fitness Center",
      "seo_description": "Discover apartments with a modern fitness center in Regent's Crest at Stonebriar Woods. Live healthy in Overland Park. Schedule a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-overland-park-ks",
      "search_query": "air-conditioned apartments in Overland Park KS",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments in Overland Park",
      "h2_subtitle": "Stay cool in Overland Park with air-conditioned apartments at Stonebriar Woods. Enjoy comfort and modern amenities in a serene setting.",
      "page_copy": "Experience comfort like never before at Stonebriar Woods Apartment Homes in Overland Park, KS, where air-conditioned apartments provide a refreshing escape from the hustle and bustle. Our one-, two-, and three-bedroom homes are designed to keep you comfortable year-round, nestled within the tranquil environment of Regent's Crest. Essential modern amenities, including stainless steel appliances and built-in bookshelves, enhance your daily living.\n\nConveniently located with direct access to Indian Creek Trail, Stonebriar Woods offers both indoor and outdoor enjoyment. Whether you’re relaxing in your cool home or exploring the trail, our community provides everything you need. Benefit from the proximity to public transportation and discover a balanced lifestyle that suits your needs. Visit us and explore how Stonebriar Woods can transform your living experience with a perfect blend of comfort and nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments in Overland Park, KS",
      "seo_description": "Find air-conditioned apartments in Overland Park, KS at Stonebriar Woods. Enjoy modern comfort and tranquility in a prime location. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-overland-park-ks",
      "search_query": "one bedroom apartments Overland Park KS",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Overland Park",
      "h2_subtitle": "Explore one-bedroom apartments at Stonebriar Woods in Overland Park. Enjoy modern amenities and a serene, convenient community setting.",
      "page_copy": "Discover the perfect blend of comfort and convenience with one-bedroom apartments at Stonebriar Woods Apartment Homes in Overland Park, KS. Our thoughtfully designed units offer ample space and modern amenities, including stainless steel appliances and built-in bookshelves, ideal for creating your personal haven.\n\nSet in the peaceful neighborhood of Regent's Crest, Stonebriar Woods provides easy access to Indian Creek Trail for those who enjoy outdoor activities. With public transportation nearby, our community offers a lifestyle of connected living, where urban conveniences meet tranquil, natural surroundings. Join us at Stonebriar Woods and find out how our one-bedroom apartments can be the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Overland Park, KS",
      "seo_description": "Find one-bedroom apartments in Overland Park, KS at Stonebriar Woods. Enjoy modern amenities and serene living. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-near-regents-crest",
      "search_query": "two bedroom apartments near Regent's Crest",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Regent's Crest",
      "h2_subtitle": "Explore spacious two-bedroom apartments near Regent's Crest at Stonebriar Woods. Enjoy a blend of modern comfort and natural beauty.",
      "page_copy": "Located in the serene neighborhood of Regent's Crest, Stonebriar Woods Apartment Homes offers beautifully crafted two-bedroom apartments that blend comfort with style. These spacious living spaces feature modern amenities such as stainless steel appliances, built-in bookshelves, and the comfort of air conditioning, perfect for both relaxation and entertainment.\n\nSituated near the Indian Creek Trail, residents can enjoy outdoor activities while living close to city conveniences. Our community in Overland Park, KS, also provides easy access to public transportation, making commuting a breeze. Discover the tranquil environment paired with the vibrant Overland Park lifestyle at Stonebriar Woods today. Schedule a tour and find out why our two-bedroom apartments are the perfect choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Regent's Crest",
      "seo_description": "Find two-bedroom apartments near Regent's Crest at Stonebriar Woods. Enjoy modern amenities and natural beauty. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-johnson-county",
      "search_query": "three bedroom apartments Johnson County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Johnson County",
      "h2_subtitle": "Find spacious three-bedroom apartments at Stonebriar Woods in Johnson County, featuring modern interiors and convenient community amenities.",
      "page_copy": "Stonebriar Woods Apartment Homes offers three-bedroom apartments in Johnson County, Kansas, with spacious layouts and modern features. Located in the Regent's Crest area of Overland Park, these apartments include stainless steel appliances and Wi-Fi for everyday convenience.\n\nThe community provides access to Indian Creek Trail, offering opportunities for walking, cycling, and outdoor recreation. Nearby public transportation connects residents to destinations throughout Overland Park and the surrounding area. Explore three-bedroom apartments at Stonebriar Woods Apartment Homes and discover the available features, community amenities, and nearby attractions. Contact the leasing team to learn more or schedule a tour.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Johnson County",
      "seo_description": "Discover spacious 3-bedroom apartments in Johnson County at Stonebriar Woods, featuring modern interiors and convenient community amenities. Schedule a tour!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-near-jccc-regnier-center-overland-park",
      "search_query": "apartments near JCCC Regnier Center Overland Park",
      "category": "School",
      "h1_title": "Apartments Near JCCC Regnier Center",
      "h2_subtitle": "Find convenient apartments near JCCC Regnier Center at Stonebriar Woods. Enjoy modern living with easy campus access in Overland Park.",
      "page_copy": "Discover the convenience of living close to Johnson County Community College's Regnier Center by choosing Stonebriar Woods Apartment Homes. Located in Overland Park, KS, our community offers one, two, and three-bedroom apartments with modern amenities like stainless steel appliances and built-in bookshelves, ensuring a comfortable and efficient living experience.\n\nSet in the picturesque Regent's Crest neighborhood, Stonebriar Woods provides more than just proximity to JCCC. With direct access to the Indian Creek Trail and nearby public transportation, residents enjoy the perfect balance of academic access and recreation. Elevate your college experience and personal lifestyle by making Stonebriar Woods your home near the JCCC Regnier Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near JCCC Regnier Center, Overland Park",
      "seo_description": "Find convenient apartments near JCCC Regnier Center at Stonebriar Woods. Enjoy modern living with campus and city access. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-close-to-oak-hill-elementary-school-ks",
      "search_query": "apartments close to Oak Hill Elementary School KS",
      "category": "School",
      "h1_title": "Apartments Near Oak Hill Elementary School",
      "h2_subtitle": "Explore apartments near Oak Hill Elementary School in Overland Park, KS, at Stonebriar Woods, featuring modern interiors and convenient community amenities.",
      "page_copy": "Stonebriar Woods Apartment Homes offers one-, two-, and three-bedroom apartments near Oak Hill Elementary School in Overland Park, Kansas. Apartment features include stainless steel appliances and Wi-Fi, combining practical amenities with functional living spaces.\n\nLocated in the Regent's Crest area of Johnson County, the community provides convenient access to Oak Hill Elementary School, Indian Creek Trail, and nearby recreational destinations. Residents can also explore local shopping, dining, and other amenities throughout Overland Park. Discover the apartment features and nearby attractions at Stonebriar Woods Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oak Hill Elementary School, KS",
      "seo_description": "Find apartments near Oak Hill Elementary School at Stonebriar Woods in Overland Park, KS, featuring modern interiors and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-near-oxford-middle-school-overland-park",
      "search_query": "apartments near Oxford Middle School Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Oxford Middle School",
      "h2_subtitle": "Discover apartments near Oxford Middle School in Overland Park at Stonebriar Woods, featuring modern interiors and convenient community amenities.",
      "page_copy": "Stonebriar Woods Apartment Homes offers one-, two-, and three-bedroom apartments near Oxford Middle School in Overland Park, Kansas. Apartment features include stainless steel appliances and Wi-Fi, combining modern conveniences with functional living spaces.\n\nLocated in the Regent's Crest area of Johnson County, the community provides access to Indian Creek Trail and nearby public transportation. Residents can also explore local schools, shopping, dining, and recreational destinations throughout Overland Park. Discover the apartment features and nearby amenities at Stonebriar Woods Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oxford Middle School, Overland Park",
      "seo_description": "Explore apartments near Oxford Middle School in Overland Park at Stonebriar Woods, featuring modern interiors and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-by-blue-valley-northwest-high-johnson-county",
      "search_query": "apartments by Blue Valley Northwest High School Johnson County",
      "category": "School",
      "h1_title": "Apartments by Blue Valley Northwest High School",
      "h2_subtitle": "Live comfortably in apartments by Blue Valley Northwest High School, located in vibrant Johnson County. Discover Stonebriar Woods today.",
      "page_copy": "Located in Overland Park, Kansas, Stonebriar Woods Apartment Homes offers one-, two-, and three-bedroom apartments near Blue Valley Northwest High School. Apartment features include stainless steel appliances and functional layouts designed for everyday living.\n\nSituated in Johnson County near the Regent's Crest neighborhood, the community provides access to Indian Creek Trail, nearby schools, and public transportation. Residents can also explore local shopping, dining, and recreational destinations throughout Overland Park. Discover the apartment features and surrounding amenities at Stonebriar Woods Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Blue Valley Northwest High School",
      "seo_description": "Find apartments near Blue Valley Northwest High School in Johnson County at Stonebriar Woods, featuring modern interiors and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-close-to-overland-trail-middle-school-66213",
      "search_query": "apartments close to Overland Trail Middle School 66213",
      "category": "School",
      "h1_title": "Apartments Near Overland Trail Middle School",
      "h2_subtitle": "Find ideal apartments close to Overland Trail Middle School in 66213. Experience elevated living with Stonebriar Woods Apartment Homes.",
      "page_copy": "Located in Overland Park, Kansas, Stonebriar Woods Apartment Homes offers one-, two-, and three-bedroom apartments near Overland Trail Middle School in the 66213 ZIP code. Apartment features include stainless steel appliances and built-in bookshelves, combining practical amenities with functional living spaces.\n\nSituated in the Regent's Crest area of Johnson County, the community provides access to Indian Creek Trail and nearby public transportation. Residents can also explore local schools, shopping, dining, and recreational destinations throughout Overland Park. Discover the apartment features and nearby amenities at Stonebriar Woods Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Trail Middle School, 66213",
      "seo_description": "Apartments near Overland Trail Middle School in the 66213 ZIP code at Stonebriar Woods Apartment Homes, featuring modern interiors and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-near-ascension-catholic-school-overland-park",
      "search_query": "apartments near Ascension Catholic School Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Ascension Catholic School",
      "h2_subtitle": "Discover inviting apartments near Ascension Catholic School, Overland Park. Experience the convenience and comfort of Stonebriar Woods Apartment Homes.",
      "page_copy": "Stonebriar Woods Apartment Homes offers one-, two-, and three-bedroom apartments near Ascension Catholic School in Overland Park, Kansas. Apartment features include Wi-Fi and stainless steel appliances, combining modern conveniences with functional living spaces.\n\nLocated in the Regent's Crest area of Johnson County, the community provides access to nearby trails and public transportation. Residents can also explore local schools, shopping, dining, and recreational destinations throughout Overland Park. Discover the apartment features and nearby amenities at Stonebriar Woods Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ascension Catholic School, Overland Park",
      "seo_description": "Live near Ascension Catholic School in Overland Park. Enjoy the peaceful community of Stonebriar Woods Apartment Homes with modern amenities and accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-near-johnson-county-community-college",
      "search_query": "apartments near Johnson County Community College",
      "category": "School",
      "h1_title": "Apartments Near Johnson County Community College",
      "h2_subtitle": "Explore comfortable apartments near Johnson County Community College. Discover Stonebriar Woods for a blend of convenience and luxury.",
      "page_copy": "Stonebriar Woods Apartment Homes in Overland Park, Kansas, offers one-, two-, and three-bedroom apartments near Johnson County Community College. Apartment features include stainless steel appliances and high-speed Wi-Fi, combining modern conveniences with functional living spaces.\n\nLocated in the Regent's Crest area of Johnson County, the community provides access to Indian Creek Trail and nearby public transportation. Residents can also explore local shopping, dining, educational institutions, and recreational destinations throughout Overland Park. Discover the apartment features and nearby amenities at Stonebriar Woods Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Johnson County Community College",
      "seo_description": "Find apartments near Johnson County Community College at Stonebriar Woods in Overland Park, featuring modern interiors and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-close-to-regents-center-regents-crest",
      "search_query": "apartments close to Regents Center Regent's Crest",
      "category": "School",
      "h1_title": "Apartments Close to Regents Center in Regent's Crest",
      "h2_subtitle": "Discover luxurious apartments close to the Regents Center within Regent's Crest. Choose Stonebriar Woods for superior Overland Park living.",
      "page_copy": "If you’re looking for stylish living in Overland Park, Stonebriar Woods Apartment Homes is conveniently located close to the Regents Center in the Regent's Crest neighborhood. Our spacious one-, two-, and three-bedroom apartments offer modern amenities like built-in bookshelves and stainless steel appliances, ensuring comfort and convenience.\n\nSituated amidst tree-framed views, Stonebriar Woods combines serene surroundings with easy accessibility, including public transportation options perfect for a commute to the Regents Center. Residents can enjoy direct trails like the Indian Creek Trail for recreational activities, making Stonebriar Woods a prime choice for balanced living near Regents Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Regents Center in Regent's Crest",
      "seo_description": "Explore Stonebriar Woods Apartments near Regents Center in Regent's Crest. Enjoy a tranquil yet connected lifestyle in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-near-brookridge-day-school-overland-park",
      "search_query": "apartments near Brookridge Day School Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Brookridge Day School",
      "h2_subtitle": "Find apartments near Brookridge Day School in Overland Park at Stonebriar Woods, featuring modern interiors and convenient community amenities.",
      "page_copy": "Stonebriar Woods Apartment Homes in Overland Park, Kansas, offers one-, two-, and three-bedroom apartments near Brookridge Day School. Apartment features include stainless steel appliances and complimentary Wi-Fi, combining modern conveniences with functional living spaces.\n\nLocated in the Regent's Crest area, the community provides access to Indian Creek Trail and nearby public transportation. Residents can also explore local schools, shopping, dining, and recreational destinations throughout Overland Park. Discover the apartment features and nearby amenities at Stonebriar Woods Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Brookridge Day School, Overland Park",
      "seo_description": "Discover apartments at Stonebriar Woods near Brookridge Day School in Overland Park, featuring modern interiors and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-near-overland-park-regional-medical-center",
      "search_query": "apartments near Overland Park Regional Medical Center",
      "category": "Hospital",
      "h1_title": "Apartments Near Overland Park Regional Medical",
      "h2_subtitle": "Look for modern apartments near Overland Park Regional Medical Center. Stonebriar Woods offers a serene escape close by.",
      "page_copy": "Situated in Overland Park, Stonebriar Woods Apartment Homes presents a perfect living option for those seeking an apartment near the Overland Park Regional Medical Center. With elegantly designed one-, two-, and three-bedroom apartments, enjoy features like built-in bookshelves and high-speed Wi-Fi that complement a busy lifestyle.\n\nOur community is nestled in the peaceful Regent's Crest neighborhood, with direct access to the scenic Indian Creek Trail. The seamless public transportation options make the commute to Overland Park Regional Medical Center easy and convenient. Experience the perfect harmony of accessibility and tranquility at Stonebriar Woods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Regional Medical Center",
      "seo_description": "Find tranquility at Stonebriar Woods, just minutes from Overland Park Regional Medical Center. Enjoy comfort and connectivity in the heart of Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "stonebriar-woods-apartments-close-to-childrens-mercy-kansas",
      "search_query": "Stonebriar Woods apartments close to Children's Mercy Kansas",
      "category": "Hospital",
      "h1_title": "Stonebriar Woods Near Children's Mercy Kansas",
      "h2_subtitle": "Discover Stonebriar Woods apartments near Children's Mercy Kansas, featuring modern interiors and convenient community amenities in Overland Park.",
      "page_copy": "Located in Overland Park, Kansas, Stonebriar Woods Apartment Homes offers one-, two-, and three-bedroom apartments near Children's Mercy Kansas. Apartment features include stainless steel appliances and complimentary Wi-Fi, combining modern conveniences with functional living spaces.\n\nSituated in the Regent's Crest area, the community provides access to public transportation and Indian Creek Trail, offering opportunities for outdoor recreation. Residents can also explore nearby medical facilities, shopping, dining, and other local destinations. Discover the apartment features and surrounding amenities at Stonebriar Woods Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonebriar Woods Near Children's Mercy Kansas",
      "seo_description": "Explore Stonebriar Woods apartments near Children's Mercy Kansas in Overland Park, with convenient access to healthcare facilities and Indian Creek Trail.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-near-overland-park-arboretum-and-botanical-gardens",
      "search_query": "apartments near overland park arboretum and botanical gardens",
      "category": "Park",
      "h1_title": "Apartments Near Overland Park Arboretum & Gardens",
      "h2_subtitle": "Discover stunning apartments near the Overland Park Arboretum and Botanical Gardens. Enjoy nature's beauty from Stonebriar Woods.",
      "page_copy": "Stonebriar Woods Apartment Homes offers an ideal living environment for nature enthusiasts looking to stay near the Overland Park Arboretum and Botanical Gardens. Our one-, two-, and three-bedroom apartment homes feature modern amenities like stainless steel appliances and built-in bookshelves, perfect for relaxation after a day outdoors.\n\nPositioned in the serene Regent's Crest neighborhood, our community ensures easy access to not only the lush landscapes of the Arboretum but also the beautiful Indian Creek Trail. Public transportation options simplify the commute to local attractions, including the botanical gardens. Immerse yourself in nature’s serenity while enjoying all the conveniences of modern living at Stonebriar Woods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Arboretum & Gardens",
      "seo_description": "Find your home at Stonebriar Woods, close to Overland Park Arboretum and Botanical Gardens. Enjoy modern living surrounded by natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "stonebriar-woods-close-to-thomas-s-stoll-memorial-park",
      "search_query": "stonebriar woods close to thomas s. stoll memorial park",
      "category": "Park",
      "h1_title": "Stonebriar Woods Near Thomas S. Stoll Park",
      "h2_subtitle": "Experience life at Stonebriar Woods, situated conveniently close to Thomas S. Stoll Memorial Park. Enjoy nature right at your doorstep.",
      "page_copy": "At Stonebriar Woods Apartment Homes, you are steps away from the picturesque Thomas S. Stoll Memorial Park. Choose from elegant one-, two-, and three-bedroom homes that provide a cozy retreat, complete with modern touches like stainless steel appliances and in-unit dryers.\n\nLocated in the charming Regent's Crest neighborhood, Stonebriar Woods offers seamless access to outdoor activities at nearby Thomas S. Stoll Park. Whether you’re biking along Indian Creek Trail or having a picnic in the park, the options are endless. Public transportation opportunities further connect you to the best of Overland Park living. Embrace a lifestyle of convenience and green spaces at Stonebriar Woods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonebriar Woods Near Thomas S. Stoll Park",
      "seo_description": "Live at Stonebriar Woods, near Thomas S. Stoll Memorial Park. Discover the balance of urban living and outdoor enjoyment in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-by-quivira-park-in-66213",
      "search_query": "apartments by quivira park in 66213",
      "category": "Park",
      "h1_title": "Apartments by Quivira Park, 66213",
      "h2_subtitle": "Find your perfect home at Stonebriar Woods, conveniently located by Quivira Park in the 66213 zip code area.",
      "page_copy": "Discover a blend of tranquility and convenience at Stonebriar Woods Apartment Homes, located near Quivira Park in the desirable 66213 area. Our one-, two-, and three-bedroom apartments come equipped with stainless steel appliances, providing a modern and functional living space tailored to your needs.\n\nSituated within Regent's Crest, Stonebriar Woods offers not only a peaceful wooded setting but also easy access to recreational activities at nearby Quivira Park. Enjoy the beauty of nature from the Indian Creek Trail or take advantage of public transportation options that make commuting around Overland Park a breeze. Experience a serene lifestyle at Stonebriar Woods, where comfort meets accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Quivira Park, 66213",
      "seo_description": "Explore Stonebriar Woods Apartments by Quivira Park in the 66213 zip code. Offering exceptional living with modern amenities and nearby park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "regents-crest-near-corporate-woods-founders-park",
      "search_query": "regent's crest proximity to corporate woods founders park",
      "category": "Park",
      "h1_title": "Regent's Crest Near Corporate Woods Founders Park",
      "h2_subtitle": "Live at Stonebriar Woods within Regent’s Crest, offering easy access to Corporate Woods Founders Park and its lush surroundings.",
      "page_copy": "Nestled in the charming neighborhood of Regent's Crest, Stonebriar Woods Apartment Homes offers an ideal setting close to Corporate Woods Founders Park. Our one-, two-, and three-bedroom homes bring you modern comforts, with amenities like Wi-Fi and built-in bookshelves, blending convenience with style.\n\nStonebriar Woods is perfectly positioned for those who appreciate outdoor leisure, thanks to its close proximity to Corporate Woods Founders Park. Enjoy scenic walks, community events, and a variety of outdoor activities while being able to retreat to your peaceful woodland home. With easy access to public transportation, exploring Overland Park is hassle-free from Regent's Crest.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Regent's Crest Near Corporate Woods Founders Park",
      "seo_description": "Discover Stonebriar Woods in Regent's Crest, perfectly located close to Corporate Woods Founders Park offering tranquility and connectivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-near-roe-park-overland-park",
      "search_query": "apartments near roe park overland park",
      "category": "Park",
      "h1_title": "Apartments Near Roe Park, Overland Park",
      "h2_subtitle": "Discover Stonebriar Woods Apartments, ideally situated near Roe Park in Overland Park for a perfect blend of comfort and nature.",
      "page_copy": "Stonebriar Woods Apartment Homes offers the ultimate living experience in Overland Park, conveniently located near the scenic Roe Park. Choose from a selection of spacious one-, two-, and three-bedroom apartments that feature modern amenities, including stainless steel appliances and Wi-Fi, to suit your lifestyle needs.\n\nSituated within the peaceful Regent's Crest neighborhood, Stonebriar Woods provides easy access to Roe Park, offering residents ample opportunities for outdoor activities and relaxation. Enjoy leisurely walks or active sports while also benefiting from the close community and public transportation links that connect you to the vibrant life of Overland Park. Experience the harmony of urban convenience and natural beauty at Stonebriar Woods Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Roe Park, Overland Park",
      "seo_description": "Explore Stonebriar Woods, ideally located near Roe Park in Overland Park. Enjoy spacious living with modern amenities and proximity to green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "stonebriar-woods-apartments-by-nall-hills-park",
      "search_query": "stonebriar woods apartments by nall hills park",
      "category": "Park",
      "h1_title": "Stonebriar Woods by Nall Hills Park",
      "h2_subtitle": "Experience serene living at Stonebriar Woods, conveniently located near Nall Hills Park, offering both peace and connectivity.",
      "page_copy": "Stonebriar Woods Apartment Homes invites you to experience peaceful living near the popular Nall Hills Park. With a choice of one-, two-, and three-bedroom residences equipped with stainless steel appliances and built-in bookshelves, our homes offer a perfect blend of style and functionality.\n\nLocated in the tranquil setting of Regent's Crest, Stonebriar Woods offers seamless access to Nall Hills Park, making it ideal for those who love outdoor activities. Enjoy the lush greenery and take advantage of public transportation options that enhance your commuting ease in Overland Park. Discover the comfort and convenience of life at Stonebriar Woods Apartments, where nature and urban living meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonebriar Woods by Nall Hills Park",
      "seo_description": "Discover Stonebriar Woods Apartments near Nall Hills Park. Enjoy modern living with natural park access and urban convenience in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "regency-lake-park-near-langston-ridge",
      "search_query": "regency lake park nearby langston ridge",
      "category": "Park",
      "h1_title": "Discover Regency Lake Park by Langston Ridge",
      "h2_subtitle": "Explore Stonebriar Woods Apartments, set amidst the scenic beauty of Regency Lake Park near Langston Ridge, offering a serene lifestyle.",
      "page_copy": "Stonebriar Woods Apartment Homes is a picturesque community located just a short distance from Regency Lake Park near Langston Ridge. Step into a welcoming sanctuary offering one-, two-, and three-bedroom options with stylish finishes like stainless steel appliances and built-in bookshelves, designed for modern living.\n\nSurrounded by natural beauty, Stonebriar Woods provides easy access to the tranquility of Regency Lake Park, perfect for leisurely walks and outdoor enjoyment. Nestled in the Regent's Crest neighborhood, our community is optimally connected while offering serene park views and public transportation convenience. Experience the harmony of peaceful nature and modern amenities at Stonebriar Woods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Discover Regency Lake Park by Langston Ridge",
      "seo_description": "Live at Stonebriar Woods near Regency Lake Park and Langston Ridge, where serene park views meet modern amenities in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "stonebriar-woods-close-to-overland-park-city-hall",
      "search_query": "stonebriar woods close to overland park city hall",
      "category": "Park",
      "h1_title": "Stonebriar Woods Near Overland Park City Hall",
      "h2_subtitle": "Enjoy convenient living at Stonebriar Woods Apartments, located near Overland Park City Hall, blending accessibility with comfort.",
      "page_copy": "Stonebriar Woods Apartment Homes offers an ideal location close to Overland Park City Hall, making it a perfect choice for those seeking connectivity and convenience. Our community provides a range of one-, two-, and three-bedroom apartments that are designed with modern features such as stainless steel appliances and Wi-Fi access to enhance your living experience.\n\nSituated in the peaceful Regent's Crest neighborhood, Stonebriar Woods ensures that you are never far from the civic hub of Overland Park. With Indian Creek Trail just steps away, enjoy the best of both worlds — serene nature and urban convenience. Public transportation options nearby also make commuting and accessing city amenities seamless. Choose Stonebriar Woods for a lifestyle of ease and accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonebriar Woods Near Overland Park City Hall",
      "seo_description": "Stonebriar Woods Apartments, close to Overland Park City Hall, offer modern living with easy access to city amenities and green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167614",
      "source": "custom",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Discover Stonebriar Woods Apartments, conveniently located near Kansas City International Airport, offering easy travel access and modern living.",
      "page_copy": "Stonebriar Woods Apartment Homes is your gateway to convenient living near Kansas City International Airport. Located in beautiful Overland Park, our community provides spacious one-, two-, and three-bedroom apartment options complete with stainless steel appliances and built-in bookshelves designed for your comfort and convenience.\n\nJust a short drive from Kansas City International Airport, Stonebriar Woods ensures residents enjoy both comfort and quick access for travel needs. Nestled within Regent's Crest, our community offers easy connection to urban amenities and serene green spaces like Indian Creek Trail. Benefit from public transportation and Wi-Fi, giving you the best of suburban peace and urban connectivity. Choose Stonebriar Woods for a lifestyle that balances accessibility and serenity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex with pool and tennis courts.",
        "public_id": "019fc989-f797-771b-8a3c-8260a8f6e60e",
        "storage_key": "property/6767906449167614/019fc989-f797-771b-8a3c-8260a8f6e60e.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Find comfort at Stonebriar Woods, offering easy access to Kansas City International Airport and a peaceful living environment in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701876532"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M2XSKCVH"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 6"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/2529cd6b-0be2-40d0-92eb-360f00d52692/app.js?nocache=1&gaTracking=G-JNBTRM4MDZ&buttonbgcolor=154734&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-675-5276"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlZ2czhPbFJUdy9EZ1owTHlSclBCRGc9PSIsInZhbHVlIjoiUjkwQnhQbTNGcmZBRmtMN3RyTXFQZz09IiwibWFjIjoiYmUzYWMyOTRiN2I5NzFkY2M4MTBkMjAxNDMyYWE3YjMyMjkxNDBjYmFiMjMwNjBmMGFjYzlmNWU3ZmNiODc1ZCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701876532",
  "custom_google_gtm_id": "GTM-M2XSKCVH",
  "custom_rollout_phase": "Batch 6",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/2529cd6b-0be2-40d0-92eb-360f00d52692/app.js?nocache=1&gaTracking=G-JNBTRM4MDZ&buttonbgcolor=154734&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-675-5276",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlZ2czhPbFJUdy9EZ1owTHlSclBCRGc9PSIsInZhbHVlIjoiUjkwQnhQbTNGcmZBRmtMN3RyTXFQZz09IiwibWFjIjoiYmUzYWMyOTRiN2I5NzFkY2M4MTBkMjAxNDMyYWE3YjMyMjkxNDBjYmFiMjMwNjBmMGFjYzlmNWU3ZmNiODc1ZCJ9",
  "custom_audioeye_site_id": "0559ffb6-b097-4f50-bb4d-2f4dff5e4e76",
  "custom_audioeye_site_hash": "3b0e0beb6803f6243e22d884b72e7f78"
};

export const generatedAt = '2026-11-03T22:56:58.251Z';
